[
  {
    "Date": "01/01/2025",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 07",
    "Zuhur": "1 09",
    "Asar": "4 33",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "02/01/2025",
    "Day": "Thu",
    "Subuh": "5 44",
    "Syuruk": "7 07",
    "Zuhur": "1 10",
    "Asar": "4 34",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "03/01/2025",
    "Day": "Fri",
    "Subuh": "5 44",
    "Syuruk": "7 08",
    "Zuhur": "1 10",
    "Asar": "4 34",
    "Maghrib": "7 11",
    "Isyak": "8 25"
  },
  {
    "Date": "04/01/2025",
    "Day": "Sat",
    "Subuh": "5 45",
    "Syuruk": "7 08",
    "Zuhur": "1 11",
    "Asar": "4 35",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "05/01/2025",
    "Day": "Sun",
    "Subuh": "5 45",
    "Syuruk": "7 09",
    "Zuhur": "1 11",
    "Asar": "4 35",
    "Maghrib": "7 12",
    "Isyak": "8 26"
  },
  {
    "Date": "06/01/2025",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 09",
    "Zuhur": "1 12",
    "Asar": "4 35",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "07/01/2025",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 10",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 13",
    "Isyak": "8 27"
  },
  {
    "Date": "08/01/2025",
    "Day": "Wed",
    "Subuh": "5 47",
    "Syuruk": "7 10",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 13",
    "Isyak": "8 27"
  },
  {
    "Date": "09/01/2025",
    "Day": "Thu",
    "Subuh": "5 47",
    "Syuruk": "7 10",
    "Zuhur": "1 13",
    "Asar": "4 37",
    "Maghrib": "7 13",
    "Isyak": "8 28"
  },
  {
    "Date": "10/01/2025",
    "Day": "Fri",
    "Subuh": "5 48",
    "Syuruk": "7 11",
    "Zuhur": "1 13",
    "Asar": "4 37",
    "Maghrib": "7 14",
    "Isyak": "8 28"
  },
  {
    "Date": "11/01/2025",
    "Day": "Sat",
    "Subuh": "5 48",
    "Syuruk": "7 11",
    "Zuhur": "1 14",
    "Asar": "4 37",
    "Maghrib": "7 14",
    "Isyak": "8 28"
  },
  {
    "Date": "12/01/2025",
    "Day": "Sun",
    "Subuh": "5 49",
    "Syuruk": "7 12",
    "Zuhur": "1 14",
    "Asar": "4 38",
    "Maghrib": "7 15",
    "Isyak": "8 29"
  },
  {
    "Date": "13/01/2025",
    "Day": "Mon",
    "Subuh": "5 49",
    "Syuruk": "7 12",
    "Zuhur": "1 15",
    "Asar": "4 38",
    "Maghrib": "7 15",
    "Isyak": "8 29"
  },
  {
    "Date": "14/01/2025",
    "Day": "Tue",
    "Subuh": "5 50",
    "Syuruk": "7 12",
    "Zuhur": "1 15",
    "Asar": "4 38",
    "Maghrib": "7 15",
    "Isyak": "8 29"
  },
  {
    "Date": "15/01/2025",
    "Day": "Wed",
    "Subuh": "5 50",
    "Syuruk": "7 13",
    "Zuhur": "1 15",
    "Asar": "4 39",
    "Maghrib": "7 16",
    "Isyak": "8 30"
  },
  {
    "Date": "16/01/2025",
    "Day": "Thu",
    "Subuh": "5 51",
    "Syuruk": "7 13",
    "Zuhur": "1 16",
    "Asar": "4 39",
    "Maghrib": "7 16",
    "Isyak": "8 30"
  },
  {
    "Date": "17/01/2025",
    "Day": "Fri",
    "Subuh": "5 51",
    "Syuruk": "7 13",
    "Zuhur": "1 16",
    "Asar": "4 39",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "18/01/2025",
    "Day": "Sat",
    "Subuh": "5 52",
    "Syuruk": "7 14",
    "Zuhur": "1 16",
    "Asar": "4 39",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "19/01/2025",
    "Day": "Sun",
    "Subuh": "5 52",
    "Syuruk": "7 14",
    "Zuhur": "1 17",
    "Asar": "4 40",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "20/01/2025",
    "Day": "Mon",
    "Subuh": "5 52",
    "Syuruk": "7 14",
    "Zuhur": "1 17",
    "Asar": "4 40",
    "Maghrib": "7 18",
    "Isyak": "8 31"
  },
  {
    "Date": "21/01/2025",
    "Day": "Tue",
    "Subuh": "5 53",
    "Syuruk": "7 15",
    "Zuhur": "1 17",
    "Asar": "4 40",
    "Maghrib": "7 18",
    "Isyak": "8 31"
  },
  {
    "Date": "22/01/2025",
    "Day": "Wed",
    "Subuh": "5 53",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 40",
    "Maghrib": "7 18",
    "Isyak": "8 31"
  },
  {
    "Date": "23/01/2025",
    "Day": "Thu",
    "Subuh": "5 54",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 40",
    "Maghrib": "7 19",
    "Isyak": "8 32"
  },
  {
    "Date": "24/01/2025",
    "Day": "Fri",
    "Subuh": "5 54",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 41",
    "Maghrib": "7 19",
    "Isyak": "8 32"
  },
  {
    "Date": "25/01/2025",
    "Day": "Sat",
    "Subuh": "5 54",
    "Syuruk": "7 16",
    "Zuhur": "1 18",
    "Asar": "4 41",
    "Maghrib": "7 19",
    "Isyak": "8 32"
  },
  {
    "Date": "26/01/2025",
    "Day": "Sun",
    "Subuh": "5 55",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 19",
    "Isyak": "8 32"
  },
  {
    "Date": "27/01/2025",
    "Day": "Mon",
    "Subuh": "5 55",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "28/01/2025",
    "Day": "Tue",
    "Subuh": "5 55",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "29/01/2025",
    "Day": "Wed",
    "Subuh": "5 56",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "30/01/2025",
    "Day": "Thu",
    "Subuh": "5 56",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "31/01/2025",
    "Day": "Fri",
    "Subuh": "5 56",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "01/02/2025",
    "Day": "Sat",
    "Subuh": "5 56",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "02/02/2025",
    "Day": "Sun",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "03/02/2025",
    "Day": "Mon",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "04/02/2025",
    "Day": "Tue",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "05/02/2025",
    "Day": "Wed",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "06/02/2025",
    "Day": "Thu",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "07/02/2025",
    "Day": "Fri",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "08/02/2025",
    "Day": "Sat",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 40",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "09/02/2025",
    "Day": "Sun",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 40",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "10/02/2025",
    "Day": "Mon",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 40",
    "Maghrib": "7 22",
    "Isyak": "8 33"
  },
  {
    "Date": "11/02/2025",
    "Day": "Tue",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 40",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "12/02/2025",
    "Day": "Wed",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 21",
    "Asar": "4 40",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "13/02/2025",
    "Day": "Thu",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 39",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "14/02/2025",
    "Day": "Fri",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 39",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "15/02/2025",
    "Day": "Sat",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 39",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "16/02/2025",
    "Day": "Sun",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 38",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "17/02/2025",
    "Day": "Mon",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 38",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "18/02/2025",
    "Day": "Tue",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 38",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "19/02/2025",
    "Day": "Wed",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 37",
    "Maghrib": "7 21",
    "Isyak": "8 32"
  },
  {
    "Date": "20/02/2025",
    "Day": "Thu",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 37",
    "Maghrib": "7 21",
    "Isyak": "8 31"
  },
  {
    "Date": "21/02/2025",
    "Day": "Fri",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 36",
    "Maghrib": "7 21",
    "Isyak": "8 31"
  },
  {
    "Date": "22/02/2025",
    "Day": "Sat",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 20",
    "Asar": "4 36",
    "Maghrib": "7 21",
    "Isyak": "8 31"
  },
  {
    "Date": "23/02/2025",
    "Day": "Sun",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 20",
    "Asar": "4 35",
    "Maghrib": "7 21",
    "Isyak": "8 31"
  },
  {
    "Date": "24/02/2025",
    "Day": "Mon",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 20",
    "Asar": "4 35",
    "Maghrib": "7 21",
    "Isyak": "8 31"
  },
  {
    "Date": "25/02/2025",
    "Day": "Tue",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 34",
    "Maghrib": "7 21",
    "Isyak": "8 31"
  },
  {
    "Date": "26/02/2025",
    "Day": "Wed",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 34",
    "Maghrib": "7 21",
    "Isyak": "8 30"
  },
  {
    "Date": "27/02/2025",
    "Day": "Thu",
    "Subuh": "5 58",
    "Syuruk": "7 15",
    "Zuhur": "1 19",
    "Asar": "4 33",
    "Maghrib": "7 21",
    "Isyak": "8 30"
  },
  {
    "Date": "28/02/2025",
    "Day": "Fri",
    "Subuh": "5 58",
    "Syuruk": "7 15",
    "Zuhur": "1 19",
    "Asar": "4 33",
    "Maghrib": "7 21",
    "Isyak": "8 30"
  },
  {
    "Date": "01/03/2025",
    "Day": "Sat",
    "Subuh": "5 58",
    "Syuruk": "7 15",
    "Zuhur": "1 19",
    "Asar": "4 32",
    "Maghrib": "7 21",
    "Isyak": "8 30"
  },
  {
    "Date": "02/03/2025",
    "Day": "Sun",
    "Subuh": "5 58",
    "Syuruk": "7 15",
    "Zuhur": "1 19",
    "Asar": "4 31",
    "Maghrib": "7 21",
    "Isyak": "8 30"
  },
  {
    "Date": "03/03/2025",
    "Day": "Mon",
    "Subuh": "5 57",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 31",
    "Maghrib": "7 21",
    "Isyak": "8 29"
  },
  {
    "Date": "04/03/2025",
    "Day": "Tue",
    "Subuh": "5 57",
    "Syuruk": "7 14",
    "Zuhur": "1 18",
    "Asar": "4 30",
    "Maghrib": "7 21",
    "Isyak": "8 29"
  },
  {
    "Date": "05/03/2025",
    "Day": "Wed",
    "Subuh": "5 57",
    "Syuruk": "7 14",
    "Zuhur": "1 18",
    "Asar": "4 29",
    "Maghrib": "7 21",
    "Isyak": "8 29"
  },
  {
    "Date": "06/03/2025",
    "Day": "Thu",
    "Subuh": "5 57",
    "Syuruk": "7 14",
    "Zuhur": "1 18",
    "Asar": "4 28",
    "Maghrib": "7 21",
    "Isyak": "8 29"
  },
  {
    "Date": "07/03/2025",
    "Day": "Fri",
    "Subuh": "5 57",
    "Syuruk": "7 14",
    "Zuhur": "1 18",
    "Asar": "4 28",
    "Maghrib": "7 20",
    "Isyak": "8 28"
  },
  {
    "Date": "08/03/2025",
    "Day": "Sat",
    "Subuh": "5 56",
    "Syuruk": "7 13",
    "Zuhur": "1 17",
    "Asar": "4 27",
    "Maghrib": "7 20",
    "Isyak": "8 28"
  },
  {
    "Date": "09/03/2025",
    "Day": "Sun",
    "Subuh": "5 56",
    "Syuruk": "7 13",
    "Zuhur": "1 17",
    "Asar": "4 26",
    "Maghrib": "7 20",
    "Isyak": "8 28"
  },
  {
    "Date": "10/03/2025",
    "Day": "Mon",
    "Subuh": "5 56",
    "Syuruk": "7 13",
    "Zuhur": "1 17",
    "Asar": "4 25",
    "Maghrib": "7 20",
    "Isyak": "8 28"
  },
  {
    "Date": "11/03/2025",
    "Day": "Tue",
    "Subuh": "5 56",
    "Syuruk": "7 13",
    "Zuhur": "1 17",
    "Asar": "4 25",
    "Maghrib": "7 19",
    "Isyak": "8 27"
  },
  {
    "Date": "12/03/2025",
    "Day": "Wed",
    "Subuh": "5 55",
    "Syuruk": "7 12",
    "Zuhur": "1 16",
    "Asar": "4 24",
    "Maghrib": "7 19",
    "Isyak": "8 27"
  },
  {
    "Date": "13/03/2025",
    "Day": "Thu",
    "Subuh": "5 55",
    "Syuruk": "7 12",
    "Zuhur": "1 16",
    "Asar": "4 23",
    "Maghrib": "7 19",
    "Isyak": "8 27"
  },
  {
    "Date": "14/03/2025",
    "Day": "Fri",
    "Subuh": "5 55",
    "Syuruk": "7 12",
    "Zuhur": "1 16",
    "Asar": "4 22",
    "Maghrib": "7 19",
    "Isyak": "8 27"
  },
  {
    "Date": "15/03/2025",
    "Day": "Sat",
    "Subuh": "5 55",
    "Syuruk": "7 11",
    "Zuhur": "1 16",
    "Asar": "4 21",
    "Maghrib": "7 19",
    "Isyak": "8 26"
  },
  {
    "Date": "16/03/2025",
    "Day": "Sun",
    "Subuh": "5 54",
    "Syuruk": "7 11",
    "Zuhur": "1 15",
    "Asar": "4 20",
    "Maghrib": "7 18",
    "Isyak": "8 26"
  },
  {
    "Date": "17/03/2025",
    "Day": "Mon",
    "Subuh": "5 54",
    "Syuruk": "7 11",
    "Zuhur": "1 15",
    "Asar": "4 19",
    "Maghrib": "7 18",
    "Isyak": "8 26"
  },
  {
    "Date": "18/03/2025",
    "Day": "Tue",
    "Subuh": "5 54",
    "Syuruk": "7 10",
    "Zuhur": "1 15",
    "Asar": "4 18",
    "Maghrib": "7 18",
    "Isyak": "8 26"
  },
  {
    "Date": "19/03/2025",
    "Day": "Wed",
    "Subuh": "5 53",
    "Syuruk": "7 10",
    "Zuhur": "1 14",
    "Asar": "4 17",
    "Maghrib": "7 18",
    "Isyak": "8 25"
  },
  {
    "Date": "20/03/2025",
    "Day": "Thu",
    "Subuh": "5 53",
    "Syuruk": "7 10",
    "Zuhur": "1 14",
    "Asar": "4 16",
    "Maghrib": "7 17",
    "Isyak": "8 25"
  },
  {
    "Date": "21/03/2025",
    "Day": "Fri",
    "Subuh": "5 53",
    "Syuruk": "7 09",
    "Zuhur": "1 14",
    "Asar": "4 15",
    "Maghrib": "7 17",
    "Isyak": "8 25"
  },
  {
    "Date": "22/03/2025",
    "Day": "Sat",
    "Subuh": "5 52",
    "Syuruk": "7 09",
    "Zuhur": "1 13",
    "Asar": "4 14",
    "Maghrib": "7 17",
    "Isyak": "8 24"
  },
  {
    "Date": "23/03/2025",
    "Day": "Sun",
    "Subuh": "5 52",
    "Syuruk": "7 09",
    "Zuhur": "1 13",
    "Asar": "4 13",
    "Maghrib": "7 17",
    "Isyak": "8 24"
  },
  {
    "Date": "24/03/2025",
    "Day": "Mon",
    "Subuh": "5 52",
    "Syuruk": "7 08",
    "Zuhur": "1 13",
    "Asar": "4 12",
    "Maghrib": "7 16",
    "Isyak": "8 24"
  },
  {
    "Date": "25/03/2025",
    "Day": "Tue",
    "Subuh": "5 51",
    "Syuruk": "7 08",
    "Zuhur": "1 13",
    "Asar": "4 12",
    "Maghrib": "7 16",
    "Isyak": "8 24"
  },
  {
    "Date": "26/03/2025",
    "Day": "Wed",
    "Subuh": "5 51",
    "Syuruk": "7 08",
    "Zuhur": "1 12",
    "Asar": "4 13",
    "Maghrib": "7 16",
    "Isyak": "8 23"
  },
  {
    "Date": "27/03/2025",
    "Day": "Thu",
    "Subuh": "5 51",
    "Syuruk": "7 07",
    "Zuhur": "1 12",
    "Asar": "4 13",
    "Maghrib": "7 15",
    "Isyak": "8 23"
  },
  {
    "Date": "28/03/2025",
    "Day": "Fri",
    "Subuh": "5 50",
    "Syuruk": "7 07",
    "Zuhur": "1 12",
    "Asar": "4 13",
    "Maghrib": "7 15",
    "Isyak": "8 23"
  },
  {
    "Date": "29/03/2025",
    "Day": "Sat",
    "Subuh": "5 50",
    "Syuruk": "7 07",
    "Zuhur": "1 11",
    "Asar": "4 14",
    "Maghrib": "7 15",
    "Isyak": "8 23"
  },
  {
    "Date": "30/03/2025",
    "Day": "Sun",
    "Subuh": "5 50",
    "Syuruk": "7 06",
    "Zuhur": "1 11",
    "Asar": "4 14",
    "Maghrib": "7 15",
    "Isyak": "8 22"
  },
  {
    "Date": "31/03/2025",
    "Day": "Mon",
    "Subuh": "5 49",
    "Syuruk": "7 06",
    "Zuhur": "1 11",
    "Asar": "4 15",
    "Maghrib": "7 13",
    "Isyak": "8 22"
  },
  {
    "Date": "01/04/2025",
    "Day": "Tue",
    "Subuh": "5 49",
    "Syuruk": "7 06",
    "Zuhur": "1 10",
    "Asar": "4 15",
    "Maghrib": "7 13",
    "Isyak": "8 22"
  },
  {
    "Date": "02/04/2025",
    "Day": "Wed",
    "Subuh": "5 48",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 15",
    "Maghrib": "7 13",
    "Isyak": "8 22"
  },
  {
    "Date": "03/04/2025",
    "Day": "Thu",
    "Subuh": "5 48",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 16",
    "Maghrib": "7 13",
    "Isyak": "8 22"
  },
  {
    "Date": "04/04/2025",
    "Day": "Fri",
    "Subuh": "5 48",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 16",
    "Maghrib": "7 12",
    "Isyak": "8 21"
  },
  {
    "Date": "05/04/2025",
    "Day": "Sat",
    "Subuh": "5 47",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 17",
    "Maghrib": "7 12",
    "Isyak": "8 21"
  },
  {
    "Date": "06/04/2025",
    "Day": "Sun",
    "Subuh": "5 47",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 17",
    "Maghrib": "7 12",
    "Isyak": "8 21"
  },
  {
    "Date": "07/04/2025",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 17",
    "Maghrib": "7 12",
    "Isyak": "8 21"
  },
  {
    "Date": "08/04/2025",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 17",
    "Maghrib": "7 11",
    "Isyak": "8 21"
  },
  {
    "Date": "09/04/2025",
    "Day": "Wed",
    "Subuh": "5 46",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 18",
    "Maghrib": "7 11",
    "Isyak": "8 20"
  },
  {
    "Date": "10/04/2025",
    "Day": "Thu",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 18",
    "Maghrib": "7 11",
    "Isyak": "8 20"
  },
  {
    "Date": "11/04/2025",
    "Day": "Fri",
    "Subuh": "5 45",
    "Syuruk": "7 02",
    "Zuhur": "1 08",
    "Asar": "4 18",
    "Maghrib": "7 11",
    "Isyak": "8 20"
  },
  {
    "Date": "12/04/2025",
    "Day": "Sat",
    "Subuh": "5 45",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "13/04/2025",
    "Day": "Sun",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "14/04/2025",
    "Day": "Mon",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "15/04/2025",
    "Day": "Tue",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 19"
  },
  {
    "Date": "16/04/2025",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 19"
  },
  {
    "Date": "17/04/2025",
    "Day": "Thu",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "18/04/2025",
    "Day": "Fri",
    "Subuh": "5 42",
    "Syuruk": "7 00",
    "Zuhur": "1 06",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "19/04/2025",
    "Day": "Sat",
    "Subuh": "5 42",
    "Syuruk": "7 00",
    "Zuhur": "1 06",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "20/04/2025",
    "Day": "Sun",
    "Subuh": "5 42",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "21/04/2025",
    "Day": "Mon",
    "Subuh": "5 41",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 21",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "22/04/2025",
    "Day": "Tue",
    "Subuh": "5 41",
    "Syuruk": "6 59",
    "Zuhur": "1 05",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "23/04/2025",
    "Day": "Wed",
    "Subuh": "5 41",
    "Syuruk": "6 59",
    "Zuhur": "1 05",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "24/04/2025",
    "Day": "Thu",
    "Subuh": "5 40",
    "Syuruk": "6 59",
    "Zuhur": "1 05",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "25/04/2025",
    "Day": "Fri",
    "Subuh": "5 40",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "26/04/2025",
    "Day": "Sat",
    "Subuh": "5 40",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "27/04/2025",
    "Day": "Sun",
    "Subuh": "5 39",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "28/04/2025",
    "Day": "Mon",
    "Subuh": "5 39",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 08",
    "Isyak": "8 18"
  },
  {
    "Date": "29/04/2025",
    "Day": "Tue",
    "Subuh": "5 39",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 07",
    "Isyak": "8 18"
  },
  {
    "Date": "30/04/2025",
    "Day": "Wed",
    "Subuh": "5 38",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 07",
    "Isyak": "8 18"
  },
  {
    "Date": "01/05/2025",
    "Day": "Thu",
    "Subuh": "5 38",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 07",
    "Isyak": "8 18"
  },
  {
    "Date": "02/05/2025",
    "Day": "Fri",
    "Subuh": "5 38",
    "Syuruk": "6 58",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "03/05/2025",
    "Day": "Sat",
    "Subuh": "5 38",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "04/05/2025",
    "Day": "Sun",
    "Subuh": "5 37",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "05/05/2025",
    "Day": "Mon",
    "Subuh": "5 37",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "06/05/2025",
    "Day": "Tue",
    "Subuh": "5 37",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "07/05/2025",
    "Day": "Wed",
    "Subuh": "5 37",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "08/05/2025",
    "Day": "Thu",
    "Subuh": "5 36",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "09/05/2025",
    "Day": "Fri",
    "Subuh": "5 36",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "10/05/2025",
    "Day": "Sat",
    "Subuh": "5 36",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "11/05/2025",
    "Day": "Sun",
    "Subuh": "5 36",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "12/05/2025",
    "Day": "Mon",
    "Subuh": "5 36",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "13/05/2025",
    "Day": "Tue",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "14/05/2025",
    "Day": "Wed",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "15/05/2025",
    "Day": "Thu",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "16/05/2025",
    "Day": "Fri",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "17/05/2025",
    "Day": "Sat",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "18/05/2025",
    "Day": "Sun",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "19/05/2025",
    "Day": "Mon",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "20/05/2025",
    "Day": "Tue",
    "Subuh": "5 34",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "21/05/2025",
    "Day": "Wed",
    "Subuh": "5 34",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 21"
  },
  {
    "Date": "22/05/2025",
    "Day": "Thu",
    "Subuh": "5 34",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 21"
  },
  {
    "Date": "23/05/2025",
    "Day": "Fri",
    "Subuh": "5 34",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 21"
  },
  {
    "Date": "24/05/2025",
    "Day": "Sat",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 07",
    "Isyak": "8 21"
  },
  {
    "Date": "25/05/2025",
    "Day": "Sun",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 08",
    "Isyak": "8 21"
  },
  {
    "Date": "26/05/2025",
    "Day": "Mon",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "27/05/2025",
    "Day": "Tue",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "28/05/2025",
    "Day": "Wed",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "29/05/2025",
    "Day": "Thu",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "30/05/2025",
    "Day": "Fri",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 08",
    "Isyak": "8 23"
  },
  {
    "Date": "31/05/2025",
    "Day": "Sat",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 08",
    "Isyak": "8 23"
  },
  {
    "Date": "01/06/2025",
    "Day": "Sun",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 09",
    "Isyak": "8 23"
  },
  {
    "Date": "02/06/2025",
    "Day": "Mon",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 23"
  },
  {
    "Date": "03/06/2025",
    "Day": "Tue",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 23"
  },
  {
    "Date": "04/06/2025",
    "Day": "Wed",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "05/06/2025",
    "Day": "Thu",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 05",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "06/06/2025",
    "Day": "Fri",
    "Subuh": "5 35",
    "Syuruk": "6 58",
    "Zuhur": "1 05",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "07/06/2025",
    "Day": "Sat",
    "Subuh": "5 35",
    "Syuruk": "6 58",
    "Zuhur": "1 05",
    "Asar": "4 30",
    "Maghrib": "7 10",
    "Isyak": "8 24"
  },
  {
    "Date": "08/06/2025",
    "Day": "Sun",
    "Subuh": "5 35",
    "Syuruk": "6 58",
    "Zuhur": "1 05",
    "Asar": "4 30",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "09/06/2025",
    "Day": "Mon",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 05",
    "Asar": "4 30",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "10/06/2025",
    "Day": "Tue",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 30",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "11/06/2025",
    "Day": "Wed",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 31",
    "Maghrib": "7 10",
    "Isyak": "8 26"
  },
  {
    "Date": "12/06/2025",
    "Day": "Thu",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 31",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "13/06/2025",
    "Day": "Fri",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 31",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "14/06/2025",
    "Day": "Sat",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 06",
    "Asar": "4 31",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "15/06/2025",
    "Day": "Sun",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 07",
    "Asar": "4 32",
    "Maghrib": "7 11",
    "Isyak": "8 27"
  },
  {
    "Date": "16/06/2025",
    "Day": "Mon",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 07",
    "Asar": "4 32",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "17/06/2025",
    "Day": "Tue",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 07",
    "Asar": "4 32",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "18/06/2025",
    "Day": "Wed",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 07",
    "Asar": "4 32",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "19/06/2025",
    "Day": "Thu",
    "Subuh": "5 36",
    "Syuruk": "7 01",
    "Zuhur": "1 07",
    "Asar": "4 33",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "20/06/2025",
    "Day": "Fri",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 08",
    "Asar": "4 33",
    "Maghrib": "7 12",
    "Isyak": "8 28"
  },
  {
    "Date": "21/06/2025",
    "Day": "Sat",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 08",
    "Asar": "4 33",
    "Maghrib": "7 13",
    "Isyak": "8 28"
  },
  {
    "Date": "22/06/2025",
    "Day": "Sun",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 08",
    "Asar": "4 33",
    "Maghrib": "7 13",
    "Isyak": "8 28"
  },
  {
    "Date": "23/06/2025",
    "Day": "Mon",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 08",
    "Asar": "4 33",
    "Maghrib": "7 13",
    "Isyak": "8 28"
  },
  {
    "Date": "24/06/2025",
    "Day": "Tue",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 13",
    "Isyak": "8 29"
  },
  {
    "Date": "25/06/2025",
    "Day": "Wed",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "26/06/2025",
    "Day": "Thu",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "27/06/2025",
    "Day": "Fri",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "28/06/2025",
    "Day": "Sat",
    "Subuh": "5 38",
    "Syuruk": "7 03",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "29/06/2025",
    "Day": "Sun",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "30/06/2025",
    "Day": "Mon",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "01/07/2025",
    "Day": "Tue",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "02/07/2025",
    "Day": "Wed",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "03/07/2025",
    "Day": "Thu",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "04/07/2025",
    "Day": "Fri",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "05/07/2025",
    "Day": "Sat",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "06/07/2025",
    "Day": "Sun",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 30"
  },
  {
    "Date": "07/07/2025",
    "Day": "Mon",
    "Subuh": "5 41",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "08/07/2025",
    "Day": "Tue",
    "Subuh": "5 41",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "09/07/2025",
    "Day": "Wed",
    "Subuh": "5 41",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "10/07/2025",
    "Day": "Thu",
    "Subuh": "5 41",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "11/07/2025",
    "Day": "Fri",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "12/07/2025",
    "Day": "Sat",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "13/07/2025",
    "Day": "Sun",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "14/07/2025",
    "Day": "Mon",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "15/07/2025",
    "Day": "Tue",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "16/07/2025",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "17/07/2025",
    "Day": "Thu",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "18/07/2025",
    "Day": "Fri",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "19/07/2025",
    "Day": "Sat",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "20/07/2025",
    "Day": "Sun",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "21/07/2025",
    "Day": "Mon",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "22/07/2025",
    "Day": "Tue",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "23/07/2025",
    "Day": "Wed",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "24/07/2025",
    "Day": "Thu",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "25/07/2025",
    "Day": "Fri",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "26/07/2025",
    "Day": "Sat",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "27/07/2025",
    "Day": "Sun",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "28/07/2025",
    "Day": "Mon",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "29/07/2025",
    "Day": "Tue",
    "Subuh": "5 45",
    "Syuruk": "7 07",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "30/07/2025",
    "Day": "Wed",
    "Subuh": "5 45",
    "Syuruk": "7 07",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "31/07/2025",
    "Day": "Thu",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "01/08/2025",
    "Day": "Fri",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 34",
    "Maghrib": "7 17",
    "Isyak": "8 29"
  },
  {
    "Date": "02/08/2025",
    "Day": "Sat",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 34",
    "Maghrib": "7 17",
    "Isyak": "8 29"
  },
  {
    "Date": "03/08/2025",
    "Day": "Sun",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 34",
    "Maghrib": "7 17",
    "Isyak": "8 29"
  },
  {
    "Date": "04/08/2025",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 34",
    "Maghrib": "7 17",
    "Isyak": "8 29"
  },
  {
    "Date": "05/08/2025",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 33",
    "Maghrib": "7 16",
    "Isyak": "8 29"
  },
  {
    "Date": "06/08/2025",
    "Day": "Wed",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 33",
    "Maghrib": "7 16",
    "Isyak": "8 28"
  },
  {
    "Date": "07/08/2025",
    "Day": "Thu",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 33",
    "Maghrib": "7 16",
    "Isyak": "8 28"
  },
  {
    "Date": "08/08/2025",
    "Day": "Fri",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 32",
    "Maghrib": "7 16",
    "Isyak": "8 28"
  },
  {
    "Date": "09/08/2025",
    "Day": "Sat",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 32",
    "Maghrib": "7 16",
    "Isyak": "8 27"
  },
  {
    "Date": "10/08/2025",
    "Day": "Sun",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 32",
    "Maghrib": "7 16",
    "Isyak": "8 27"
  },
  {
    "Date": "11/08/2025",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 31",
    "Maghrib": "7 15",
    "Isyak": "8 27"
  },
  {
    "Date": "12/08/2025",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 31",
    "Maghrib": "7 15",
    "Isyak": "8 27"
  },
  {
    "Date": "13/08/2025",
    "Day": "Wed",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 30",
    "Maghrib": "7 15",
    "Isyak": "8 26"
  },
  {
    "Date": "14/08/2025",
    "Day": "Thu",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 30",
    "Maghrib": "7 15",
    "Isyak": "8 26"
  },
  {
    "Date": "15/08/2025",
    "Day": "Fri",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 29",
    "Maghrib": "7 15",
    "Isyak": "8 26"
  },
  {
    "Date": "16/08/2025",
    "Day": "Sat",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 29",
    "Maghrib": "7 14",
    "Isyak": "8 25"
  },
  {
    "Date": "17/08/2025",
    "Day": "Sun",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 28",
    "Maghrib": "7 14",
    "Isyak": "8 25"
  },
  {
    "Date": "18/08/2025",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 28",
    "Maghrib": "7 14",
    "Isyak": "8 25"
  },
  {
    "Date": "19/08/2025",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 27",
    "Maghrib": "7 14",
    "Isyak": "8 24"
  },
  {
    "Date": "20/08/2025",
    "Day": "Wed",
    "Subuh": "5 46",
    "Syuruk": "7 04",
    "Zuhur": "1 10",
    "Asar": "4 26",
    "Maghrib": "7 13",
    "Isyak": "8 24"
  },
  {
    "Date": "21/08/2025",
    "Day": "Thu",
    "Subuh": "5 45",
    "Syuruk": "7 04",
    "Zuhur": "1 10",
    "Asar": "4 26",
    "Maghrib": "7 13",
    "Isyak": "8 24"
  },
  {
    "Date": "22/08/2025",
    "Day": "Fri",
    "Subuh": "5 45",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 25",
    "Maghrib": "7 13",
    "Isyak": "8 23"
  },
  {
    "Date": "23/08/2025",
    "Day": "Sat",
    "Subuh": "5 45",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 25",
    "Maghrib": "7 13",
    "Isyak": "8 23"
  },
  {
    "Date": "24/08/2025",
    "Day": "Sun",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 09",
    "Asar": "4 24",
    "Maghrib": "7 12",
    "Isyak": "8 22"
  },
  {
    "Date": "25/08/2025",
    "Day": "Mon",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 09",
    "Asar": "4 23",
    "Maghrib": "7 12",
    "Isyak": "8 22"
  },
  {
    "Date": "26/08/2025",
    "Day": "Tue",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 23",
    "Maghrib": "7 12",
    "Isyak": "8 22"
  },
  {
    "Date": "27/08/2025",
    "Day": "Wed",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 22",
    "Maghrib": "7 11",
    "Isyak": "8 21"
  },
  {
    "Date": "28/08/2025",
    "Day": "Thu",
    "Subuh": "5 45",
    "Syuruk": "7 02",
    "Zuhur": "1 08",
    "Asar": "4 21",
    "Maghrib": "7 11",
    "Isyak": "8 21"
  },
  {
    "Date": "29/08/2025",
    "Day": "Fri",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 08",
    "Asar": "4 20",
    "Maghrib": "7 11",
    "Isyak": "8 20"
  },
  {
    "Date": "30/08/2025",
    "Day": "Sat",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 20",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "31/08/2025",
    "Day": "Sun",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "01/09/2025",
    "Day": "Mon",
    "Subuh": "5 44",
    "Syuruk": "7 01",
    "Zuhur": "1 07",
    "Asar": "4 18",
    "Maghrib": "7 10",
    "Isyak": "8 19"
  },
  {
    "Date": "02/09/2025",
    "Day": "Tue",
    "Subuh": "5 44",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 17",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "03/09/2025",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 16",
    "Maghrib": "7 09",
    "Isyak": "8 18"
  },
  {
    "Date": "04/09/2025",
    "Day": "Thu",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 15",
    "Maghrib": "7 09",
    "Isyak": "8 18"
  },
  {
    "Date": "05/09/2025",
    "Day": "Fri",
    "Subuh": "5 43",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 15",
    "Maghrib": "7 08",
    "Isyak": "8 18"
  },
  {
    "Date": "06/09/2025",
    "Day": "Sat",
    "Subuh": "5 43",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 14",
    "Maghrib": "7 08",
    "Isyak": "8 17"
  },
  {
    "Date": "07/09/2025",
    "Day": "Sun",
    "Subuh": "5 42",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 13",
    "Maghrib": "7 08",
    "Isyak": "8 17"
  },
  {
    "Date": "08/09/2025",
    "Day": "Mon",
    "Subuh": "5 42",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 12",
    "Maghrib": "7 07",
    "Isyak": "8 16"
  },
  {
    "Date": "09/09/2025",
    "Day": "Tue",
    "Subuh": "5 42",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 11",
    "Maghrib": "7 07",
    "Isyak": "8 16"
  },
  {
    "Date": "10/09/2025",
    "Day": "Wed",
    "Subuh": "5 42",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 10",
    "Maghrib": "7 06",
    "Isyak": "8 15"
  },
  {
    "Date": "11/09/2025",
    "Day": "Thu",
    "Subuh": "5 41",
    "Syuruk": "6 58",
    "Zuhur": "1 03",
    "Asar": "4 09",
    "Maghrib": "7 06",
    "Isyak": "8 15"
  },
  {
    "Date": "12/09/2025",
    "Day": "Fri",
    "Subuh": "5 41",
    "Syuruk": "6 58",
    "Zuhur": "1 03",
    "Asar": "4 08",
    "Maghrib": "7 06",
    "Isyak": "8 15"
  },
  {
    "Date": "13/09/2025",
    "Day": "Sat",
    "Subuh": "5 41",
    "Syuruk": "6 58",
    "Zuhur": "1 03",
    "Asar": "4 07",
    "Maghrib": "7 05",
    "Isyak": "8 14"
  },
  {
    "Date": "14/09/2025",
    "Day": "Sun",
    "Subuh": "5 41",
    "Syuruk": "6 57",
    "Zuhur": "1 02",
    "Asar": "4 06",
    "Maghrib": "7 05",
    "Isyak": "8 14"
  },
  {
    "Date": "15/09/2025",
    "Day": "Mon",
    "Subuh": "5 40",
    "Syuruk": "6 57",
    "Zuhur": "1 02",
    "Asar": "4 05",
    "Maghrib": "7 04",
    "Isyak": "8 13"
  },
  {
    "Date": "16/09/2025",
    "Day": "Tue",
    "Subuh": "5 40",
    "Syuruk": "6 57",
    "Zuhur": "1 02",
    "Asar": "4 04",
    "Maghrib": "7 04",
    "Isyak": "8 13"
  },
  {
    "Date": "17/09/2025",
    "Day": "Wed",
    "Subuh": "5 40",
    "Syuruk": "6 57",
    "Zuhur": "1 01",
    "Asar": "4 03",
    "Maghrib": "7 04",
    "Isyak": "8 12"
  },
  {
    "Date": "18/09/2025",
    "Day": "Thu",
    "Subuh": "5 39",
    "Syuruk": "6 56",
    "Zuhur": "1 01",
    "Asar": "4 02",
    "Maghrib": "7 03",
    "Isyak": "8 12"
  },
  {
    "Date": "19/09/2025",
    "Day": "Fri",
    "Subuh": "5 39",
    "Syuruk": "6 56",
    "Zuhur": "1 00",
    "Asar": "4 00",
    "Maghrib": "7 03",
    "Isyak": "8 12"
  },
  {
    "Date": "20/09/2025",
    "Day": "Sat",
    "Subuh": "5 39",
    "Syuruk": "6 56",
    "Zuhur": "1 00",
    "Asar": "3 59",
    "Maghrib": "7 02",
    "Isyak": "8 11"
  },
  {
    "Date": "21/09/2025",
    "Day": "Sun",
    "Subuh": "5 39",
    "Syuruk": "6 55",
    "Zuhur": "1 00",
    "Asar": "3 59",
    "Maghrib": "7 02",
    "Isyak": "8 11"
  },
  {
    "Date": "22/09/2025",
    "Day": "Mon",
    "Subuh": "5 38",
    "Syuruk": "6 55",
    "Zuhur": "12 59",
    "Asar": "4 00",
    "Maghrib": "7 02",
    "Isyak": "8 10"
  },
  {
    "Date": "23/09/2025",
    "Day": "Tue",
    "Subuh": "5 38",
    "Syuruk": "6 55",
    "Zuhur": "12 59",
    "Asar": "4 00",
    "Maghrib": "7 01",
    "Isyak": "8 10"
  },
  {
    "Date": "24/09/2025",
    "Day": "Wed",
    "Subuh": "5 38",
    "Syuruk": "6 54",
    "Zuhur": "12 59",
    "Asar": "4 00",
    "Maghrib": "7 01",
    "Isyak": "8 10"
  },
  {
    "Date": "25/09/2025",
    "Day": "Thu",
    "Subuh": "5 37",
    "Syuruk": "6 54",
    "Zuhur": "12 58",
    "Asar": "4 01",
    "Maghrib": "7 01",
    "Isyak": "8 09"
  },
  {
    "Date": "26/09/2025",
    "Day": "Fri",
    "Subuh": "5 37",
    "Syuruk": "6 54",
    "Zuhur": "12 58",
    "Asar": "4 01",
    "Maghrib": "7 00",
    "Isyak": "8 09"
  },
  {
    "Date": "27/09/2025",
    "Day": "Sat",
    "Subuh": "5 37",
    "Syuruk": "6 53",
    "Zuhur": "12 58",
    "Asar": "4 01",
    "Maghrib": "7 00",
    "Isyak": "8 08"
  },
  {
    "Date": "28/09/2025",
    "Day": "Sun",
    "Subuh": "5 36",
    "Syuruk": "6 53",
    "Zuhur": "12 57",
    "Asar": "4 02",
    "Maghrib": "6 59",
    "Isyak": "8 08"
  },
  {
    "Date": "29/09/2025",
    "Day": "Mon",
    "Subuh": "5 36",
    "Syuruk": "6 53",
    "Zuhur": "12 57",
    "Asar": "4 02",
    "Maghrib": "6 59",
    "Isyak": "8 08"
  },
  {
    "Date": "30/09/2025",
    "Day": "Tue",
    "Subuh": "5 36",
    "Syuruk": "6 52",
    "Zuhur": "12 57",
    "Asar": "4 02",
    "Maghrib": "6 59",
    "Isyak": "8 07"
  },
  {
    "Date": "01/10/2025",
    "Day": "Wed",
    "Subuh": "5 35",
    "Syuruk": "6 52",
    "Zuhur": "12 56",
    "Asar": "4 03",
    "Maghrib": "6 58",
    "Isyak": "8 07"
  },
  {
    "Date": "02/10/2025",
    "Day": "Thu",
    "Subuh": "5 35",
    "Syuruk": "6 52",
    "Zuhur": "12 56",
    "Asar": "4 03",
    "Maghrib": "6 58",
    "Isyak": "8 07"
  },
  {
    "Date": "03/10/2025",
    "Day": "Fri",
    "Subuh": "5 35",
    "Syuruk": "6 52",
    "Zuhur": "12 56",
    "Asar": "4 03",
    "Maghrib": "6 58",
    "Isyak": "8 06"
  },
  {
    "Date": "04/10/2025",
    "Day": "Sat",
    "Subuh": "5 34",
    "Syuruk": "6 51",
    "Zuhur": "12 55",
    "Asar": "4 03",
    "Maghrib": "6 57",
    "Isyak": "8 06"
  },
  {
    "Date": "05/10/2025",
    "Day": "Sun",
    "Subuh": "5 34",
    "Syuruk": "6 51",
    "Zuhur": "12 55",
    "Asar": "4 04",
    "Maghrib": "6 57",
    "Isyak": "8 06"
  },
  {
    "Date": "06/10/2025",
    "Day": "Mon",
    "Subuh": "5 34",
    "Syuruk": "6 51",
    "Zuhur": "12 55",
    "Asar": "4 04",
    "Maghrib": "6 57",
    "Isyak": "8 05"
  },
  {
    "Date": "07/10/2025",
    "Day": "Tue",
    "Subuh": "5 33",
    "Syuruk": "6 50",
    "Zuhur": "12 54",
    "Asar": "4 04",
    "Maghrib": "6 56",
    "Isyak": "8 05"
  },
  {
    "Date": "08/10/2025",
    "Day": "Wed",
    "Subuh": "5 33",
    "Syuruk": "6 50",
    "Zuhur": "12 54",
    "Asar": "4 04",
    "Maghrib": "6 56",
    "Isyak": "8 05"
  },
  {
    "Date": "09/10/2025",
    "Day": "Thu",
    "Subuh": "5 33",
    "Syuruk": "6 50",
    "Zuhur": "12 54",
    "Asar": "4 05",
    "Maghrib": "6 56",
    "Isyak": "8 05"
  },
  {
    "Date": "10/10/2025",
    "Day": "Fri",
    "Subuh": "5 33",
    "Syuruk": "6 50",
    "Zuhur": "12 54",
    "Asar": "4 05",
    "Maghrib": "6 55",
    "Isyak": "8 04"
  },
  {
    "Date": "11/10/2025",
    "Day": "Sat",
    "Subuh": "5 32",
    "Syuruk": "6 49",
    "Zuhur": "12 53",
    "Asar": "4 05",
    "Maghrib": "6 55",
    "Isyak": "8 04"
  },
  {
    "Date": "12/10/2025",
    "Day": "Sun",
    "Subuh": "5 32",
    "Syuruk": "6 49",
    "Zuhur": "12 53",
    "Asar": "4 05",
    "Maghrib": "6 55",
    "Isyak": "8 04"
  },
  {
    "Date": "13/10/2025",
    "Day": "Mon",
    "Subuh": "5 32",
    "Syuruk": "6 49",
    "Zuhur": "12 53",
    "Asar": "4 05",
    "Maghrib": "6 54",
    "Isyak": "8 04"
  },
  {
    "Date": "14/10/2025",
    "Day": "Tue",
    "Subuh": "5 31",
    "Syuruk": "6 49",
    "Zuhur": "12 53",
    "Asar": "4 06",
    "Maghrib": "6 54",
    "Isyak": "8 03"
  },
  {
    "Date": "15/10/2025",
    "Day": "Wed",
    "Subuh": "5 31",
    "Syuruk": "6 49",
    "Zuhur": "12 52",
    "Asar": "4 06",
    "Maghrib": "6 54",
    "Isyak": "8 03"
  },
  {
    "Date": "16/10/2025",
    "Day": "Thu",
    "Subuh": "5 31",
    "Syuruk": "6 48",
    "Zuhur": "12 52",
    "Asar": "4 06",
    "Maghrib": "6 54",
    "Isyak": "8 03"
  },
  {
    "Date": "17/10/2025",
    "Day": "Fri",
    "Subuh": "5 31",
    "Syuruk": "6 48",
    "Zuhur": "12 52",
    "Asar": "4 06",
    "Maghrib": "6 53",
    "Isyak": "8 03"
  },
  {
    "Date": "18/10/2025",
    "Day": "Sat",
    "Subuh": "5 30",
    "Syuruk": "6 48",
    "Zuhur": "12 52",
    "Asar": "4 06",
    "Maghrib": "6 53",
    "Isyak": "8 03"
  },
  {
    "Date": "19/10/2025",
    "Day": "Sun",
    "Subuh": "5 30",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 53",
    "Isyak": "8 03"
  },
  {
    "Date": "20/10/2025",
    "Day": "Mon",
    "Subuh": "5 30",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 53",
    "Isyak": "8 02"
  },
  {
    "Date": "21/10/2025",
    "Day": "Tue",
    "Subuh": "5 30",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "22/10/2025",
    "Day": "Wed",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "23/10/2025",
    "Day": "Thu",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "24/10/2025",
    "Day": "Fri",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 51",
    "Asar": "4 08",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "25/10/2025",
    "Day": "Sat",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "26/10/2025",
    "Day": "Sun",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "27/10/2025",
    "Day": "Mon",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "28/10/2025",
    "Day": "Tue",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "29/10/2025",
    "Day": "Wed",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "30/10/2025",
    "Day": "Thu",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "31/10/2025",
    "Day": "Fri",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "01/11/2025",
    "Day": "Sat",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "02/11/2025",
    "Day": "Sun",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "03/11/2025",
    "Day": "Mon",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "04/11/2025",
    "Day": "Tue",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "05/11/2025",
    "Day": "Wed",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "06/11/2025",
    "Day": "Thu",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "07/11/2025",
    "Day": "Fri",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "08/11/2025",
    "Day": "Sat",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 11",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "09/11/2025",
    "Day": "Sun",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 11",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "10/11/2025",
    "Day": "Mon",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 11",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "11/11/2025",
    "Day": "Tue",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 11",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "12/11/2025",
    "Day": "Wed",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 12",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "13/11/2025",
    "Day": "Thu",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 12",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "14/11/2025",
    "Day": "Fri",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 12",
    "Maghrib": "6 51",
    "Isyak": "8 04"
  },
  {
    "Date": "15/11/2025",
    "Day": "Sat",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 13",
    "Maghrib": "6 51",
    "Isyak": "8 04"
  },
  {
    "Date": "16/11/2025",
    "Day": "Sun",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 13",
    "Maghrib": "6 52",
    "Isyak": "8 04"
  },
  {
    "Date": "17/11/2025",
    "Day": "Mon",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 13",
    "Maghrib": "6 52",
    "Isyak": "8 04"
  },
  {
    "Date": "18/11/2025",
    "Day": "Tue",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 14",
    "Maghrib": "6 52",
    "Isyak": "8 05"
  },
  {
    "Date": "19/11/2025",
    "Day": "Wed",
    "Subuh": "5 27",
    "Syuruk": "6 49",
    "Zuhur": "12 51",
    "Asar": "4 14",
    "Maghrib": "6 52",
    "Isyak": "8 05"
  },
  {
    "Date": "20/11/2025",
    "Day": "Thu",
    "Subuh": "5 27",
    "Syuruk": "6 49",
    "Zuhur": "12 52",
    "Asar": "4 14",
    "Maghrib": "6 52",
    "Isyak": "8 05"
  },
  {
    "Date": "21/11/2025",
    "Day": "Fri",
    "Subuh": "5 28",
    "Syuruk": "6 49",
    "Zuhur": "12 52",
    "Asar": "4 15",
    "Maghrib": "6 53",
    "Isyak": "8 06"
  },
  {
    "Date": "22/11/2025",
    "Day": "Sat",
    "Subuh": "5 28",
    "Syuruk": "6 49",
    "Zuhur": "12 52",
    "Asar": "4 15",
    "Maghrib": "6 53",
    "Isyak": "8 06"
  },
  {
    "Date": "23/11/2025",
    "Day": "Sun",
    "Subuh": "5 28",
    "Syuruk": "6 50",
    "Zuhur": "12 52",
    "Asar": "4 15",
    "Maghrib": "6 53",
    "Isyak": "8 06"
  },
  {
    "Date": "24/11/2025",
    "Day": "Mon",
    "Subuh": "5 28",
    "Syuruk": "6 50",
    "Zuhur": "12 53",
    "Asar": "4 16",
    "Maghrib": "6 53",
    "Isyak": "8 07"
  },
  {
    "Date": "25/11/2025",
    "Day": "Tue",
    "Subuh": "5 28",
    "Syuruk": "6 50",
    "Zuhur": "12 53",
    "Asar": "4 16",
    "Maghrib": "6 54",
    "Isyak": "8 07"
  },
  {
    "Date": "26/11/2025",
    "Day": "Wed",
    "Subuh": "5 28",
    "Syuruk": "6 51",
    "Zuhur": "12 53",
    "Asar": "4 16",
    "Maghrib": "6 54",
    "Isyak": "8 07"
  },
  {
    "Date": "27/11/2025",
    "Day": "Thu",
    "Subuh": "5 29",
    "Syuruk": "6 51",
    "Zuhur": "12 54",
    "Asar": "4 17",
    "Maghrib": "6 54",
    "Isyak": "8 08"
  },
  {
    "Date": "28/11/2025",
    "Day": "Fri",
    "Subuh": "5 29",
    "Syuruk": "6 51",
    "Zuhur": "12 54",
    "Asar": "4 17",
    "Maghrib": "6 54",
    "Isyak": "8 08"
  },
  {
    "Date": "29/11/2025",
    "Day": "Sat",
    "Subuh": "5 29",
    "Syuruk": "6 52",
    "Zuhur": "12 54",
    "Asar": "4 18",
    "Maghrib": "6 55",
    "Isyak": "8 09"
  },
  {
    "Date": "30/11/2025",
    "Day": "Sun",
    "Subuh": "5 29",
    "Syuruk": "6 52",
    "Zuhur": "12 55",
    "Asar": "4 18",
    "Maghrib": "6 55",
    "Isyak": "8 09"
  },
  {
    "Date": "01/12/2025",
    "Day": "Mon",
    "Subuh": "5 30",
    "Syuruk": "6 52",
    "Zuhur": "12 55",
    "Asar": "4 18",
    "Maghrib": "6 55",
    "Isyak": "8 09"
  },
  {
    "Date": "02/12/2025",
    "Day": "Tue",
    "Subuh": "5 30",
    "Syuruk": "6 53",
    "Zuhur": "12 55",
    "Asar": "4 19",
    "Maghrib": "6 56",
    "Isyak": "8 10"
  },
  {
    "Date": "03/12/2025",
    "Day": "Wed",
    "Subuh": "5 30",
    "Syuruk": "6 53",
    "Zuhur": "12 56",
    "Asar": "4 19",
    "Maghrib": "6 56",
    "Isyak": "8 10"
  },
  {
    "Date": "04/12/2025",
    "Day": "Thu",
    "Subuh": "5 31",
    "Syuruk": "6 53",
    "Zuhur": "12 56",
    "Asar": "4 20",
    "Maghrib": "6 57",
    "Isyak": "8 11"
  },
  {
    "Date": "05/12/2025",
    "Day": "Fri",
    "Subuh": "5 31",
    "Syuruk": "6 54",
    "Zuhur": "12 56",
    "Asar": "4 20",
    "Maghrib": "6 57",
    "Isyak": "8 11"
  },
  {
    "Date": "06/12/2025",
    "Day": "Sat",
    "Subuh": "5 31",
    "Syuruk": "6 54",
    "Zuhur": "12 57",
    "Asar": "4 21",
    "Maghrib": "6 57",
    "Isyak": "8 12"
  },
  {
    "Date": "07/12/2025",
    "Day": "Sun",
    "Subuh": "5 32",
    "Syuruk": "6 55",
    "Zuhur": "12 57",
    "Asar": "4 21",
    "Maghrib": "6 58",
    "Isyak": "8 12"
  },
  {
    "Date": "08/12/2025",
    "Day": "Mon",
    "Subuh": "5 32",
    "Syuruk": "6 55",
    "Zuhur": "12 58",
    "Asar": "4 21",
    "Maghrib": "6 58",
    "Isyak": "8 13"
  },
  {
    "Date": "09/12/2025",
    "Day": "Tue",
    "Subuh": "5 32",
    "Syuruk": "6 56",
    "Zuhur": "12 58",
    "Asar": "4 22",
    "Maghrib": "6 59",
    "Isyak": "8 13"
  },
  {
    "Date": "10/12/2025",
    "Day": "Wed",
    "Subuh": "5 33",
    "Syuruk": "6 56",
    "Zuhur": "12 59",
    "Asar": "4 22",
    "Maghrib": "6 59",
    "Isyak": "8 14"
  },
  {
    "Date": "11/12/2025",
    "Day": "Thu",
    "Subuh": "5 33",
    "Syuruk": "6 57",
    "Zuhur": "12 59",
    "Asar": "4 23",
    "Maghrib": "6 59",
    "Isyak": "8 14"
  },
  {
    "Date": "12/12/2025",
    "Day": "Fri",
    "Subuh": "5 33",
    "Syuruk": "6 57",
    "Zuhur": "1 00",
    "Asar": "4 23",
    "Maghrib": "7 00",
    "Isyak": "8 15"
  },
  {
    "Date": "13/12/2025",
    "Day": "Sat",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 00",
    "Asar": "4 24",
    "Maghrib": "7 00",
    "Isyak": "8 15"
  },
  {
    "Date": "14/12/2025",
    "Day": "Sun",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 00",
    "Asar": "4 24",
    "Maghrib": "7 01",
    "Isyak": "8 16"
  },
  {
    "Date": "15/12/2025",
    "Day": "Mon",
    "Subuh": "5 35",
    "Syuruk": "6 58",
    "Zuhur": "1 01",
    "Asar": "4 25",
    "Maghrib": "7 01",
    "Isyak": "8 16"
  },
  {
    "Date": "16/12/2025",
    "Day": "Tue",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 01",
    "Asar": "4 25",
    "Maghrib": "7 02",
    "Isyak": "8 17"
  },
  {
    "Date": "17/12/2025",
    "Day": "Wed",
    "Subuh": "5 36",
    "Syuruk": "6 59",
    "Zuhur": "1 02",
    "Asar": "4 26",
    "Maghrib": "7 02",
    "Isyak": "8 17"
  },
  {
    "Date": "18/12/2025",
    "Day": "Thu",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 02",
    "Asar": "4 26",
    "Maghrib": "7 03",
    "Isyak": "8 18"
  },
  {
    "Date": "19/12/2025",
    "Day": "Fri",
    "Subuh": "5 37",
    "Syuruk": "7 00",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 03",
    "Isyak": "8 18"
  },
  {
    "Date": "20/12/2025",
    "Day": "Sat",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 04",
    "Isyak": "8 19"
  },
  {
    "Date": "21/12/2025",
    "Day": "Sun",
    "Subuh": "5 38",
    "Syuruk": "7 01",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 04",
    "Isyak": "8 19"
  },
  {
    "Date": "22/12/2025",
    "Day": "Mon",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 05",
    "Isyak": "8 20"
  },
  {
    "Date": "23/12/2025",
    "Day": "Tue",
    "Subuh": "5 39",
    "Syuruk": "7 02",
    "Zuhur": "1 05",
    "Asar": "4 29",
    "Maghrib": "7 05",
    "Isyak": "8 20"
  },
  {
    "Date": "24/12/2025",
    "Day": "Wed",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 05",
    "Asar": "4 29",
    "Maghrib": "7 06",
    "Isyak": "8 21"
  },
  {
    "Date": "25/12/2025",
    "Day": "Thu",
    "Subuh": "5 40",
    "Syuruk": "7 03",
    "Zuhur": "1 06",
    "Asar": "4 30",
    "Maghrib": "7 06",
    "Isyak": "8 21"
  },
  {
    "Date": "26/12/2025",
    "Day": "Fri",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 06",
    "Asar": "4 30",
    "Maghrib": "7 07",
    "Isyak": "8 22"
  },
  {
    "Date": "27/12/2025",
    "Day": "Sat",
    "Subuh": "5 41",
    "Syuruk": "7 04",
    "Zuhur": "1 07",
    "Asar": "4 31",
    "Maghrib": "7 07",
    "Isyak": "8 22"
  },
  {
    "Date": "28/12/2025",
    "Day": "Sun",
    "Subuh": "5 41",
    "Syuruk": "7 05",
    "Zuhur": "1 07",
    "Asar": "4 31",
    "Maghrib": "7 08",
    "Isyak": "8 23"
  },
  {
    "Date": "29/12/2025",
    "Day": "Mon",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 08",
    "Asar": "4 32",
    "Maghrib": "7 08",
    "Isyak": "8 23"
  },
  {
    "Date": "30/12/2025",
    "Day": "Tue",
    "Subuh": "5 42",
    "Syuruk": "7 06",
    "Zuhur": "1 08",
    "Asar": "4 32",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "31/12/2025",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 09",
    "Asar": "4 33",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "01/01/2026",
    "Day": "Thu",
    "Subuh": "5 44",
    "Syuruk": "7 08",
    "Zuhur": "1 10",
    "Asar": "4 34",
    "Maghrib": "7 11",
    "Isyak": "8 25"
  },
  {
    "Date": "02/01/2026",
    "Day": "Fri",
    "Subuh": "5 45",
    "Syuruk": "7 08",
    "Zuhur": "1 11",
    "Asar": "4 35",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "03/01/2026",
    "Day": "Sat",
    "Subuh": "5 45",
    "Syuruk": "7 09",
    "Zuhur": "1 11",
    "Asar": "4 35",
    "Maghrib": "7 12",
    "Isyak": "8 26"
  },
  {
    "Date": "04/01/2026",
    "Day": "Sun",
    "Subuh": "5 46",
    "Syuruk": "7 09",
    "Zuhur": "1 12",
    "Asar": "4 35",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "05/01/2026",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 09",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "06/01/2026",
    "Day": "Tue",
    "Subuh": "5 47",
    "Syuruk": "7 10",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 13",
    "Isyak": "8 27"
  },
  {
    "Date": "07/01/2026",
    "Day": "Wed",
    "Subuh": "5 47",
    "Syuruk": "7 10",
    "Zuhur": "1 13",
    "Asar": "4 37",
    "Maghrib": "7 13",
    "Isyak": "8 28"
  },
  {
    "Date": "08/01/2026",
    "Day": "Thu",
    "Subuh": "5 48",
    "Syuruk": "7 11",
    "Zuhur": "1 13",
    "Asar": "4 37",
    "Maghrib": "7 14",
    "Isyak": "8 28"
  },
  {
    "Date": "09/01/2026",
    "Day": "Fri",
    "Subuh": "5 48",
    "Syuruk": "7 11",
    "Zuhur": "1 14",
    "Asar": "4 37",
    "Maghrib": "7 14",
    "Isyak": "8 28"
  },
  {
    "Date": "10/01/2026",
    "Day": "Sat",
    "Subuh": "5 49",
    "Syuruk": "7 11",
    "Zuhur": "1 14",
    "Asar": "4 38",
    "Maghrib": "7 15",
    "Isyak": "8 29"
  },
  {
    "Date": "11/01/2026",
    "Day": "Sun",
    "Subuh": "5 49",
    "Syuruk": "7 12",
    "Zuhur": "1 15",
    "Asar": "4 38",
    "Maghrib": "7 15",
    "Isyak": "8 29"
  },
  {
    "Date": "12/01/2026",
    "Day": "Mon",
    "Subuh": "5 50",
    "Syuruk": "7 12",
    "Zuhur": "1 15",
    "Asar": "4 38",
    "Maghrib": "7 15",
    "Isyak": "8 29"
  },
  {
    "Date": "13/01/2026",
    "Day": "Tue",
    "Subuh": "5 50",
    "Syuruk": "7 13",
    "Zuhur": "1 15",
    "Asar": "4 39",
    "Maghrib": "7 16",
    "Isyak": "8 30"
  },
  {
    "Date": "14/01/2026",
    "Day": "Wed",
    "Subuh": "5 51",
    "Syuruk": "7 13",
    "Zuhur": "1 16",
    "Asar": "4 39",
    "Maghrib": "7 16",
    "Isyak": "8 30"
  },
  {
    "Date": "15/01/2026",
    "Day": "Thu",
    "Subuh": "5 51",
    "Syuruk": "7 13",
    "Zuhur": "1 16",
    "Asar": "4 39",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "16/01/2026",
    "Day": "Fri",
    "Subuh": "5 51",
    "Syuruk": "7 14",
    "Zuhur": "1 16",
    "Asar": "4 39",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "17/01/2026",
    "Day": "Sat",
    "Subuh": "5 52",
    "Syuruk": "7 14",
    "Zuhur": "1 17",
    "Asar": "4 40",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "18/01/2026",
    "Day": "Sun",
    "Subuh": "5 52",
    "Syuruk": "7 14",
    "Zuhur": "1 17",
    "Asar": "4 40",
    "Maghrib": "7 18",
    "Isyak": "8 31"
  },
  {
    "Date": "19/01/2026",
    "Day": "Mon",
    "Subuh": "5 53",
    "Syuruk": "7 14",
    "Zuhur": "1 17",
    "Asar": "4 40",
    "Maghrib": "7 18",
    "Isyak": "8 31"
  },
  {
    "Date": "20/01/2026",
    "Day": "Tue",
    "Subuh": "5 53",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 40",
    "Maghrib": "7 18",
    "Isyak": "8 31"
  },
  {
    "Date": "21/01/2026",
    "Day": "Wed",
    "Subuh": "5 53",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 40",
    "Maghrib": "7 18",
    "Isyak": "8 31"
  },
  {
    "Date": "22/01/2026",
    "Day": "Thu",
    "Subuh": "5 54",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 41",
    "Maghrib": "7 19",
    "Isyak": "8 32"
  },
  {
    "Date": "23/01/2026",
    "Day": "Fri",
    "Subuh": "5 54",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 41",
    "Maghrib": "7 19",
    "Isyak": "8 32"
  },
  {
    "Date": "24/01/2026",
    "Day": "Sat",
    "Subuh": "5 55",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 19",
    "Isyak": "8 32"
  },
  {
    "Date": "25/01/2026",
    "Day": "Sun",
    "Subuh": "5 55",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "26/01/2026",
    "Day": "Mon",
    "Subuh": "5 55",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "27/01/2026",
    "Day": "Tue",
    "Subuh": "5 55",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "28/01/2026",
    "Day": "Wed",
    "Subuh": "5 56",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "29/01/2026",
    "Day": "Thu",
    "Subuh": "5 56",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 20",
    "Isyak": "8 32"
  },
  {
    "Date": "30/01/2026",
    "Day": "Fri",
    "Subuh": "5 56",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "31/01/2026",
    "Day": "Sat",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "01/02/2026",
    "Day": "Sun",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "02/02/2026",
    "Day": "Mon",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "03/02/2026",
    "Day": "Tue",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "04/02/2026",
    "Day": "Wed",
    "Subuh": "5 57",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "05/02/2026",
    "Day": "Thu",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 41",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "06/02/2026",
    "Day": "Fri",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 40",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "07/02/2026",
    "Day": "Sat",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 40",
    "Maghrib": "7 21",
    "Isyak": "8 33"
  },
  {
    "Date": "08/02/2026",
    "Day": "Sun",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 40",
    "Maghrib": "7 22",
    "Isyak": "8 33"
  },
  {
    "Date": "09/02/2026",
    "Day": "Mon",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 40",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "10/02/2026",
    "Day": "Tue",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 21",
    "Asar": "4 40",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "11/02/2026",
    "Day": "Wed",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 39",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "12/02/2026",
    "Day": "Thu",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 39",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "13/02/2026",
    "Day": "Fri",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 39",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "14/02/2026",
    "Day": "Sat",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 38",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "15/02/2026",
    "Day": "Sun",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 38",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "16/02/2026",
    "Day": "Mon",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 38",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "17/02/2026",
    "Day": "Tue",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 37",
    "Maghrib": "7 22",
    "Isyak": "8 32"
  },
  {
    "Date": "18/02/2026",
    "Day": "Wed",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 37",
    "Maghrib": "7 21",
    "Isyak": "8 31"
  },
  {
    "Date": "19/02/2026",
    "Day": "Thu",
    "Subuh": "5 58",
    "Syuruk": "7 17",
    "Zuhur": "1 20",
    "Asar": "4 36",
    "Maghrib": "7 22",
    "Isyak": "8 31"
  },
  {
    "Date": "20/02/2026",
    "Day": "Fri",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 20",
    "Asar": "4 36",
    "Maghrib": "7 22",
    "Isyak": "8 31"
  },
  {
    "Date": "21/02/2026",
    "Day": "Sat",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 20",
    "Asar": "4 35",
    "Maghrib": "7 22",
    "Isyak": "8 31"
  },
  {
    "Date": "22/02/2026",
    "Day": "Sun",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 20",
    "Asar": "4 35",
    "Maghrib": "7 22",
    "Isyak": "8 31"
  },
  {
    "Date": "23/02/2026",
    "Day": "Mon",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 20",
    "Asar": "4 34",
    "Maghrib": "7 22",
    "Isyak": "8 31"
  },
  {
    "Date": "24/02/2026",
    "Day": "Tue",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 34",
    "Maghrib": "7 22",
    "Isyak": "8 30"
  },
  {
    "Date": "25/02/2026",
    "Day": "Wed",
    "Subuh": "5 58",
    "Syuruk": "7 16",
    "Zuhur": "1 19",
    "Asar": "4 33",
    "Maghrib": "7 22",
    "Isyak": "8 30"
  },
  {
    "Date": "26/02/2026",
    "Day": "Thu",
    "Subuh": "5 58",
    "Syuruk": "7 15",
    "Zuhur": "1 19",
    "Asar": "4 33",
    "Maghrib": "7 22",
    "Isyak": "8 30"
  },
  {
    "Date": "27/02/2026",
    "Day": "Fri",
    "Subuh": "5 58",
    "Syuruk": "7 15",
    "Zuhur": "1 19",
    "Asar": "4 32",
    "Maghrib": "7 21",
    "Isyak": "8 30"
  },
  {
    "Date": "28/02/2026",
    "Day": "Sat",
    "Subuh": "5 58",
    "Syuruk": "7 15",
    "Zuhur": "1 19",
    "Asar": "4 31",
    "Maghrib": "7 21",
    "Isyak": "8 30"
  },
  {
    "Date": "01/03/2026",
    "Day": "Sun",
    "Subuh": "5 57",
    "Syuruk": "7 15",
    "Zuhur": "1 18",
    "Asar": "4 31",
    "Maghrib": "7 21",
    "Isyak": "8 29"
  },
  {
    "Date": "02/03/2026",
    "Day": "Mon",
    "Subuh": "5 57",
    "Syuruk": "7 14",
    "Zuhur": "1 18",
    "Asar": "4 30",
    "Maghrib": "7 21",
    "Isyak": "8 29"
  },
  {
    "Date": "03/03/2026",
    "Day": "Tue",
    "Subuh": "5 57",
    "Syuruk": "7 14",
    "Zuhur": "1 18",
    "Asar": "4 29",
    "Maghrib": "7 21",
    "Isyak": "8 29"
  },
  {
    "Date": "04/03/2026",
    "Day": "Wed",
    "Subuh": "5 57",
    "Syuruk": "7 14",
    "Zuhur": "1 18",
    "Asar": "4 29",
    "Maghrib": "7 21",
    "Isyak": "8 29"
  },
  {
    "Date": "05/03/2026",
    "Day": "Thu",
    "Subuh": "5 57",
    "Syuruk": "7 14",
    "Zuhur": "1 18",
    "Asar": "4 28",
    "Maghrib": "7 20",
    "Isyak": "8 28"
  },
  {
    "Date": "06/03/2026",
    "Day": "Fri",
    "Subuh": "5 56",
    "Syuruk": "7 13",
    "Zuhur": "1 17",
    "Asar": "4 27",
    "Maghrib": "7 20",
    "Isyak": "8 28"
  },
  {
    "Date": "07/03/2026",
    "Day": "Sat",
    "Subuh": "5 56",
    "Syuruk": "7 13",
    "Zuhur": "1 17",
    "Asar": "4 26",
    "Maghrib": "7 20",
    "Isyak": "8 28"
  },
  {
    "Date": "08/03/2026",
    "Day": "Sun",
    "Subuh": "5 56",
    "Syuruk": "7 13",
    "Zuhur": "1 17",
    "Asar": "4 26",
    "Maghrib": "7 20",
    "Isyak": "8 28"
  },
  {
    "Date": "09/03/2026",
    "Day": "Mon",
    "Subuh": "5 56",
    "Syuruk": "7 13",
    "Zuhur": "1 17",
    "Asar": "4 25",
    "Maghrib": "7 20",
    "Isyak": "8 27"
  },
  {
    "Date": "10/03/2026",
    "Day": "Tue",
    "Subuh": "5 55",
    "Syuruk": "7 12",
    "Zuhur": "1 16",
    "Asar": "4 24",
    "Maghrib": "7 19",
    "Isyak": "8 27"
  },
  {
    "Date": "11/03/2026",
    "Day": "Wed",
    "Subuh": "5 55",
    "Syuruk": "7 12",
    "Zuhur": "1 16",
    "Asar": "4 23",
    "Maghrib": "7 19",
    "Isyak": "8 27"
  },
  {
    "Date": "12/03/2026",
    "Day": "Thu",
    "Subuh": "5 55",
    "Syuruk": "7 12",
    "Zuhur": "1 16",
    "Asar": "4 22",
    "Maghrib": "7 19",
    "Isyak": "8 27"
  },
  {
    "Date": "13/03/2026",
    "Day": "Fri",
    "Subuh": "5 55",
    "Syuruk": "7 11",
    "Zuhur": "1 16",
    "Asar": "4 21",
    "Maghrib": "7 19",
    "Isyak": "8 26"
  },
  {
    "Date": "14/03/2026",
    "Day": "Sat",
    "Subuh": "5 54",
    "Syuruk": "7 11",
    "Zuhur": "1 15",
    "Asar": "4 20",
    "Maghrib": "7 18",
    "Isyak": "8 26"
  },
  {
    "Date": "15/03/2026",
    "Day": "Sun",
    "Subuh": "5 54",
    "Syuruk": "7 11",
    "Zuhur": "1 15",
    "Asar": "4 19",
    "Maghrib": "7 18",
    "Isyak": "8 26"
  },
  {
    "Date": "16/03/2026",
    "Day": "Mon",
    "Subuh": "5 54",
    "Syuruk": "7 10",
    "Zuhur": "1 15",
    "Asar": "4 18",
    "Maghrib": "7 18",
    "Isyak": "8 26"
  },
  {
    "Date": "17/03/2026",
    "Day": "Tue",
    "Subuh": "5 53",
    "Syuruk": "7 10",
    "Zuhur": "1 14",
    "Asar": "4 18",
    "Maghrib": "7 18",
    "Isyak": "8 25"
  },
  {
    "Date": "18/03/2026",
    "Day": "Wed",
    "Subuh": "5 53",
    "Syuruk": "7 10",
    "Zuhur": "1 14",
    "Asar": "4 17",
    "Maghrib": "7 17",
    "Isyak": "8 25"
  },
  {
    "Date": "19/03/2026",
    "Day": "Thu",
    "Subuh": "5 53",
    "Syuruk": "7 09",
    "Zuhur": "1 14",
    "Asar": "4 16",
    "Maghrib": "7 17",
    "Isyak": "8 25"
  },
  {
    "Date": "20/03/2026",
    "Day": "Fri",
    "Subuh": "5 52",
    "Syuruk": "7 09",
    "Zuhur": "1 14",
    "Asar": "4 14",
    "Maghrib": "7 17",
    "Isyak": "8 25"
  },
  {
    "Date": "21/03/2026",
    "Day": "Sat",
    "Subuh": "5 52",
    "Syuruk": "7 09",
    "Zuhur": "1 13",
    "Asar": "4 13",
    "Maghrib": "7 16",
    "Isyak": "8 24"
  },
  {
    "Date": "22/03/2026",
    "Day": "Sun",
    "Subuh": "5 52",
    "Syuruk": "7 08",
    "Zuhur": "1 13",
    "Asar": "4 12",
    "Maghrib": "7 15",
    "Isyak": "8 24"
  },
  {
    "Date": "23/03/2026",
    "Day": "Mon",
    "Subuh": "5 51",
    "Syuruk": "7 08",
    "Zuhur": "1 13",
    "Asar": "4 12",
    "Maghrib": "7 15",
    "Isyak": "8 24"
  },
  {
    "Date": "24/03/2026",
    "Day": "Tue",
    "Subuh": "5 51",
    "Syuruk": "7 08",
    "Zuhur": "1 12",
    "Asar": "4 12",
    "Maghrib": "7 15",
    "Isyak": "8 24"
  },
  {
    "Date": "25/03/2026",
    "Day": "Wed",
    "Subuh": "5 51",
    "Syuruk": "7 07",
    "Zuhur": "1 12",
    "Asar": "4 13",
    "Maghrib": "7 15",
    "Isyak": "8 23"
  },
  {
    "Date": "26/03/2026",
    "Day": "Thu",
    "Subuh": "5 50",
    "Syuruk": "7 07",
    "Zuhur": "1 12",
    "Asar": "4 13",
    "Maghrib": "7 14",
    "Isyak": "8 23"
  },
  {
    "Date": "27/03/2026",
    "Day": "Fri",
    "Subuh": "5 50",
    "Syuruk": "7 07",
    "Zuhur": "1 11",
    "Asar": "4 14",
    "Maghrib": "7 14",
    "Isyak": "8 23"
  },
  {
    "Date": "28/03/2026",
    "Day": "Sat",
    "Subuh": "5 50",
    "Syuruk": "7 06",
    "Zuhur": "1 11",
    "Asar": "4 14",
    "Maghrib": "7 14",
    "Isyak": "8 23"
  },
  {
    "Date": "29/03/2026",
    "Day": "Sun",
    "Subuh": "5 49",
    "Syuruk": "7 06",
    "Zuhur": "1 11",
    "Asar": "4 15",
    "Maghrib": "7 13",
    "Isyak": "8 22"
  },
  {
    "Date": "30/03/2026",
    "Day": "Mon",
    "Subuh": "5 49",
    "Syuruk": "7 06",
    "Zuhur": "1 11",
    "Asar": "4 15",
    "Maghrib": "7 13",
    "Isyak": "8 22"
  },
  {
    "Date": "31/03/2026",
    "Day": "Tue",
    "Subuh": "5 48",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 15",
    "Maghrib": "7 13",
    "Isyak": "8 22"
  },
  {
    "Date": "01/04/2026",
    "Day": "Wed",
    "Subuh": "5 48",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 16",
    "Maghrib": "7 13",
    "Isyak": "8 22"
  },
  {
    "Date": "02/04/2026",
    "Day": "Thu",
    "Subuh": "5 48",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 16",
    "Maghrib": "7 12",
    "Isyak": "8 21"
  },
  {
    "Date": "03/04/2026",
    "Day": "Fri",
    "Subuh": "5 47",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 16",
    "Maghrib": "7 12",
    "Isyak": "8 21"
  },
  {
    "Date": "04/04/2026",
    "Day": "Sat",
    "Subuh": "5 47",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 17",
    "Maghrib": "7 12",
    "Isyak": "8 21"
  },
  {
    "Date": "05/04/2026",
    "Day": "Sun",
    "Subuh": "5 47",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 17",
    "Maghrib": "7 12",
    "Isyak": "8 21"
  },
  {
    "Date": "06/04/2026",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 03",
    "Zuhur": "1 09",
    "Asar": "4 17",
    "Maghrib": "7 11",
    "Isyak": "8 21"
  },
  {
    "Date": "07/04/2026",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 18",
    "Maghrib": "7 11",
    "Isyak": "8 20"
  },
  {
    "Date": "08/04/2026",
    "Day": "Wed",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 18",
    "Maghrib": "7 11",
    "Isyak": "8 20"
  },
  {
    "Date": "09/04/2026",
    "Day": "Thu",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 18",
    "Maghrib": "7 11",
    "Isyak": "8 20"
  },
  {
    "Date": "10/04/2026",
    "Day": "Fri",
    "Subuh": "5 45",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 18",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "11/04/2026",
    "Day": "Sat",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "12/04/2026",
    "Day": "Sun",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "13/04/2026",
    "Day": "Mon",
    "Subuh": "5 44",
    "Syuruk": "7 01",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "14/04/2026",
    "Day": "Tue",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 19"
  },
  {
    "Date": "15/04/2026",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "16/04/2026",
    "Day": "Thu",
    "Subuh": "5 42",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "17/04/2026",
    "Day": "Fri",
    "Subuh": "5 42",
    "Syuruk": "7 00",
    "Zuhur": "1 06",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "18/04/2026",
    "Day": "Sat",
    "Subuh": "5 42",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "19/04/2026",
    "Day": "Sun",
    "Subuh": "5 41",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 20",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "20/04/2026",
    "Day": "Mon",
    "Subuh": "5 41",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "21/04/2026",
    "Day": "Tue",
    "Subuh": "5 41",
    "Syuruk": "6 59",
    "Zuhur": "1 05",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "22/04/2026",
    "Day": "Wed",
    "Subuh": "5 40",
    "Syuruk": "6 59",
    "Zuhur": "1 05",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "23/04/2026",
    "Day": "Thu",
    "Subuh": "5 40",
    "Syuruk": "6 59",
    "Zuhur": "1 05",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "24/04/2026",
    "Day": "Fri",
    "Subuh": "5 40",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 21",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "25/04/2026",
    "Day": "Sat",
    "Subuh": "5 39",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "26/04/2026",
    "Day": "Sun",
    "Subuh": "5 39",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 08",
    "Isyak": "8 19"
  },
  {
    "Date": "27/04/2026",
    "Day": "Mon",
    "Subuh": "5 39",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 08",
    "Isyak": "8 18"
  },
  {
    "Date": "28/04/2026",
    "Day": "Tue",
    "Subuh": "5 38",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 07",
    "Isyak": "8 18"
  },
  {
    "Date": "29/04/2026",
    "Day": "Wed",
    "Subuh": "5 38",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 22",
    "Maghrib": "7 07",
    "Isyak": "8 18"
  },
  {
    "Date": "30/04/2026",
    "Day": "Thu",
    "Subuh": "5 38",
    "Syuruk": "6 58",
    "Zuhur": "1 03",
    "Asar": "4 22",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "01/05/2026",
    "Day": "Fri",
    "Subuh": "5 38",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "02/05/2026",
    "Day": "Sat",
    "Subuh": "5 37",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "03/05/2026",
    "Day": "Sun",
    "Subuh": "5 37",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "04/05/2026",
    "Day": "Mon",
    "Subuh": "5 37",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "05/05/2026",
    "Day": "Tue",
    "Subuh": "5 37",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 23",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "06/05/2026",
    "Day": "Wed",
    "Subuh": "5 36",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "07/05/2026",
    "Day": "Thu",
    "Subuh": "5 36",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "08/05/2026",
    "Day": "Fri",
    "Subuh": "5 36",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "09/05/2026",
    "Day": "Sat",
    "Subuh": "5 36",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "10/05/2026",
    "Day": "Sun",
    "Subuh": "5 36",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "11/05/2026",
    "Day": "Mon",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 24",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "12/05/2026",
    "Day": "Tue",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 19"
  },
  {
    "Date": "13/05/2026",
    "Day": "Wed",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "14/05/2026",
    "Day": "Thu",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "15/05/2026",
    "Day": "Fri",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "16/05/2026",
    "Day": "Sat",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 25",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "17/05/2026",
    "Day": "Sun",
    "Subuh": "5 35",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "18/05/2026",
    "Day": "Mon",
    "Subuh": "5 34",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 20"
  },
  {
    "Date": "19/05/2026",
    "Day": "Tue",
    "Subuh": "5 34",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 21"
  },
  {
    "Date": "20/05/2026",
    "Day": "Wed",
    "Subuh": "5 34",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 21"
  },
  {
    "Date": "21/05/2026",
    "Day": "Thu",
    "Subuh": "5 34",
    "Syuruk": "6 56",
    "Zuhur": "1 03",
    "Asar": "4 26",
    "Maghrib": "7 07",
    "Isyak": "8 21"
  },
  {
    "Date": "22/05/2026",
    "Day": "Fri",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 07",
    "Isyak": "8 21"
  },
  {
    "Date": "23/05/2026",
    "Day": "Sat",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 08",
    "Isyak": "8 21"
  },
  {
    "Date": "24/05/2026",
    "Day": "Sun",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "25/05/2026",
    "Day": "Mon",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "26/05/2026",
    "Day": "Tue",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "27/05/2026",
    "Day": "Wed",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "28/05/2026",
    "Day": "Thu",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "29/05/2026",
    "Day": "Fri",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 08",
    "Isyak": "8 23"
  },
  {
    "Date": "30/05/2026",
    "Day": "Sat",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 09",
    "Isyak": "8 23"
  },
  {
    "Date": "31/05/2026",
    "Day": "Sun",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 04",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 23"
  },
  {
    "Date": "01/06/2026",
    "Day": "Mon",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 23"
  },
  {
    "Date": "02/06/2026",
    "Day": "Tue",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 04",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "03/06/2026",
    "Day": "Wed",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 05",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "04/06/2026",
    "Day": "Thu",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 05",
    "Asar": "4 29",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "05/06/2026",
    "Day": "Fri",
    "Subuh": "5 35",
    "Syuruk": "6 58",
    "Zuhur": "1 05",
    "Asar": "4 30",
    "Maghrib": "7 10",
    "Isyak": "8 24"
  },
  {
    "Date": "06/06/2026",
    "Day": "Sat",
    "Subuh": "5 35",
    "Syuruk": "6 58",
    "Zuhur": "1 05",
    "Asar": "4 30",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "07/06/2026",
    "Day": "Sun",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 05",
    "Asar": "4 30",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "08/06/2026",
    "Day": "Mon",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 30",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "09/06/2026",
    "Day": "Tue",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 31",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  },
  {
    "Date": "10/06/2026",
    "Day": "Wed",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 31",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "11/06/2026",
    "Day": "Thu",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 31",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "12/06/2026",
    "Day": "Fri",
    "Subuh": "5 36",
    "Syuruk": "6 59",
    "Zuhur": "1 06",
    "Asar": "4 31",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "13/06/2026",
    "Day": "Sat",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 07",
    "Asar": "4 32",
    "Maghrib": "7 11",
    "Isyak": "8 26"
  },
  {
    "Date": "14/06/2026",
    "Day": "Sun",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 07",
    "Asar": "4 32",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "15/06/2026",
    "Day": "Mon",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 07",
    "Asar": "4 32",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "16/06/2026",
    "Day": "Tue",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 07",
    "Asar": "4 32",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "17/06/2026",
    "Day": "Wed",
    "Subuh": "5 36",
    "Syuruk": "7 01",
    "Zuhur": "1 07",
    "Asar": "4 33",
    "Maghrib": "7 12",
    "Isyak": "8 27"
  },
  {
    "Date": "18/06/2026",
    "Day": "Thu",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 08",
    "Asar": "4 33",
    "Maghrib": "7 12",
    "Isyak": "8 28"
  },
  {
    "Date": "19/06/2026",
    "Day": "Fri",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 08",
    "Asar": "4 33",
    "Maghrib": "7 13",
    "Isyak": "8 28"
  },
  {
    "Date": "20/06/2026",
    "Day": "Sat",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 08",
    "Asar": "4 33",
    "Maghrib": "7 13",
    "Isyak": "8 28"
  },
  {
    "Date": "21/06/2026",
    "Day": "Sun",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 08",
    "Asar": "4 33",
    "Maghrib": "7 13",
    "Isyak": "8 28"
  },
  {
    "Date": "22/06/2026",
    "Day": "Mon",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 13",
    "Isyak": "8 29"
  },
  {
    "Date": "23/06/2026",
    "Day": "Tue",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 13",
    "Isyak": "8 29"
  },
  {
    "Date": "24/06/2026",
    "Day": "Wed",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "25/06/2026",
    "Day": "Thu",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "26/06/2026",
    "Day": "Fri",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 09",
    "Asar": "4 34",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "27/06/2026",
    "Day": "Sat",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 14",
    "Isyak": "8 29"
  },
  {
    "Date": "28/06/2026",
    "Day": "Sun",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 14",
    "Isyak": "8 30"
  },
  {
    "Date": "29/06/2026",
    "Day": "Mon",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "30/06/2026",
    "Day": "Tue",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "01/07/2026",
    "Day": "Wed",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 10",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "02/07/2026",
    "Day": "Thu",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 35",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "03/07/2026",
    "Day": "Fri",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 15",
    "Isyak": "8 30"
  },
  {
    "Date": "04/07/2026",
    "Day": "Sat",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 30"
  },
  {
    "Date": "05/07/2026",
    "Day": "Sun",
    "Subuh": "5 41",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "06/07/2026",
    "Day": "Mon",
    "Subuh": "5 41",
    "Syuruk": "7 04",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "07/07/2026",
    "Day": "Tue",
    "Subuh": "5 41",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "08/07/2026",
    "Day": "Wed",
    "Subuh": "5 41",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "09/07/2026",
    "Day": "Thu",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "10/07/2026",
    "Day": "Fri",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 16",
    "Isyak": "8 31"
  },
  {
    "Date": "11/07/2026",
    "Day": "Sat",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "12/07/2026",
    "Day": "Sun",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "13/07/2026",
    "Day": "Mon",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "14/07/2026",
    "Day": "Tue",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "15/07/2026",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "16/07/2026",
    "Day": "Thu",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "17/07/2026",
    "Day": "Fri",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "18/07/2026",
    "Day": "Sat",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "19/07/2026",
    "Day": "Sun",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "20/07/2026",
    "Day": "Mon",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "21/07/2026",
    "Day": "Tue",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "22/07/2026",
    "Day": "Wed",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 31"
  },
  {
    "Date": "23/07/2026",
    "Day": "Thu",
    "Subuh": "5 44",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "24/07/2026",
    "Day": "Fri",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "25/07/2026",
    "Day": "Sat",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 36",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "26/07/2026",
    "Day": "Sun",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "27/07/2026",
    "Day": "Mon",
    "Subuh": "5 45",
    "Syuruk": "7 07",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "28/07/2026",
    "Day": "Tue",
    "Subuh": "5 45",
    "Syuruk": "7 07",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "29/07/2026",
    "Day": "Wed",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 30"
  },
  {
    "Date": "30/07/2026",
    "Day": "Thu",
    "Subuh": "5 45",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 35",
    "Maghrib": "7 17",
    "Isyak": "8 29"
  },
  {
    "Date": "31/07/2026",
    "Day": "Fri",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 34",
    "Maghrib": "7 17",
    "Isyak": "8 29"
  },
  {
    "Date": "01/08/2026",
    "Day": "Sat",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 34",
    "Maghrib": "7 17",
    "Isyak": "8 29"
  },
  {
    "Date": "02/08/2026",
    "Day": "Sun",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 13",
    "Asar": "4 34",
    "Maghrib": "7 17",
    "Isyak": "8 29"
  },
  {
    "Date": "03/08/2026",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 33",
    "Maghrib": "7 16",
    "Isyak": "8 29"
  },
  {
    "Date": "04/08/2026",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 33",
    "Maghrib": "7 16",
    "Isyak": "8 28"
  },
  {
    "Date": "05/08/2026",
    "Day": "Wed",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 33",
    "Maghrib": "7 16",
    "Isyak": "8 28"
  },
  {
    "Date": "06/08/2026",
    "Day": "Thu",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 32",
    "Maghrib": "7 16",
    "Isyak": "8 28"
  },
  {
    "Date": "07/08/2026",
    "Day": "Fri",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 32",
    "Maghrib": "7 16",
    "Isyak": "8 28"
  },
  {
    "Date": "08/08/2026",
    "Day": "Sat",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 32",
    "Maghrib": "7 16",
    "Isyak": "8 27"
  },
  {
    "Date": "09/08/2026",
    "Day": "Sun",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 31",
    "Maghrib": "7 16",
    "Isyak": "8 27"
  },
  {
    "Date": "10/08/2026",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 12",
    "Asar": "4 31",
    "Maghrib": "7 15",
    "Isyak": "8 27"
  },
  {
    "Date": "11/08/2026",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 06",
    "Zuhur": "1 11",
    "Asar": "4 30",
    "Maghrib": "7 15",
    "Isyak": "8 26"
  },
  {
    "Date": "12/08/2026",
    "Day": "Wed",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 30",
    "Maghrib": "7 15",
    "Isyak": "8 26"
  },
  {
    "Date": "13/08/2026",
    "Day": "Thu",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 29",
    "Maghrib": "7 15",
    "Isyak": "8 26"
  },
  {
    "Date": "14/08/2026",
    "Day": "Fri",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 29",
    "Maghrib": "7 14",
    "Isyak": "8 25"
  },
  {
    "Date": "15/08/2026",
    "Day": "Sat",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 11",
    "Asar": "4 28",
    "Maghrib": "7 14",
    "Isyak": "8 25"
  },
  {
    "Date": "16/08/2026",
    "Day": "Sun",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 28",
    "Maghrib": "7 14",
    "Isyak": "8 25"
  },
  {
    "Date": "17/08/2026",
    "Day": "Mon",
    "Subuh": "5 46",
    "Syuruk": "7 05",
    "Zuhur": "1 10",
    "Asar": "4 27",
    "Maghrib": "7 14",
    "Isyak": "8 24"
  },
  {
    "Date": "18/08/2026",
    "Day": "Tue",
    "Subuh": "5 46",
    "Syuruk": "7 04",
    "Zuhur": "1 10",
    "Asar": "4 27",
    "Maghrib": "7 13",
    "Isyak": "8 24"
  },
  {
    "Date": "19/08/2026",
    "Day": "Wed",
    "Subuh": "5 45",
    "Syuruk": "7 04",
    "Zuhur": "1 10",
    "Asar": "4 26",
    "Maghrib": "7 13",
    "Isyak": "8 24"
  },
  {
    "Date": "20/08/2026",
    "Day": "Thu",
    "Subuh": "5 45",
    "Syuruk": "7 04",
    "Zuhur": "1 10",
    "Asar": "4 25",
    "Maghrib": "7 13",
    "Isyak": "8 23"
  },
  {
    "Date": "21/08/2026",
    "Day": "Fri",
    "Subuh": "5 45",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 25",
    "Maghrib": "7 13",
    "Isyak": "8 23"
  },
  {
    "Date": "22/08/2026",
    "Day": "Sat",
    "Subuh": "5 45",
    "Syuruk": "7 04",
    "Zuhur": "1 09",
    "Asar": "4 24",
    "Maghrib": "7 12",
    "Isyak": "8 23"
  },
  {
    "Date": "23/08/2026",
    "Day": "Sun",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 09",
    "Asar": "4 23",
    "Maghrib": "7 12",
    "Isyak": "8 22"
  },
  {
    "Date": "24/08/2026",
    "Day": "Mon",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 23",
    "Maghrib": "7 12",
    "Isyak": "8 22"
  },
  {
    "Date": "25/08/2026",
    "Day": "Tue",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 22",
    "Maghrib": "7 11",
    "Isyak": "8 21"
  },
  {
    "Date": "26/08/2026",
    "Day": "Wed",
    "Subuh": "5 45",
    "Syuruk": "7 03",
    "Zuhur": "1 08",
    "Asar": "4 21",
    "Maghrib": "7 11",
    "Isyak": "8 21"
  },
  {
    "Date": "27/08/2026",
    "Day": "Thu",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 08",
    "Asar": "4 21",
    "Maghrib": "7 11",
    "Isyak": "8 21"
  },
  {
    "Date": "28/08/2026",
    "Day": "Fri",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 20",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "29/08/2026",
    "Day": "Sat",
    "Subuh": "5 44",
    "Syuruk": "7 02",
    "Zuhur": "1 07",
    "Asar": "4 19",
    "Maghrib": "7 10",
    "Isyak": "8 20"
  },
  {
    "Date": "30/08/2026",
    "Day": "Sun",
    "Subuh": "5 44",
    "Syuruk": "7 01",
    "Zuhur": "1 07",
    "Asar": "4 18",
    "Maghrib": "7 10",
    "Isyak": "8 19"
  },
  {
    "Date": "31/08/2026",
    "Day": "Mon",
    "Subuh": "5 44",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 17",
    "Maghrib": "7 09",
    "Isyak": "8 19"
  },
  {
    "Date": "01/09/2026",
    "Day": "Tue",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 17",
    "Maghrib": "7 09",
    "Isyak": "8 18"
  },
  {
    "Date": "02/09/2026",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 01",
    "Zuhur": "1 06",
    "Asar": "4 16",
    "Maghrib": "7 09",
    "Isyak": "8 18"
  },
  {
    "Date": "03/09/2026",
    "Day": "Thu",
    "Subuh": "5 43",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 15",
    "Maghrib": "7 08",
    "Isyak": "8 18"
  },
  {
    "Date": "04/09/2026",
    "Day": "Fri",
    "Subuh": "5 43",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 14",
    "Maghrib": "7 08",
    "Isyak": "8 17"
  },
  {
    "Date": "05/09/2026",
    "Day": "Sat",
    "Subuh": "5 43",
    "Syuruk": "7 00",
    "Zuhur": "1 05",
    "Asar": "4 13",
    "Maghrib": "7 08",
    "Isyak": "8 17"
  },
  {
    "Date": "06/09/2026",
    "Day": "Sun",
    "Subuh": "5 42",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 12",
    "Maghrib": "7 07",
    "Isyak": "8 16"
  },
  {
    "Date": "07/09/2026",
    "Day": "Mon",
    "Subuh": "5 42",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 11",
    "Maghrib": "7 07",
    "Isyak": "8 16"
  },
  {
    "Date": "08/09/2026",
    "Day": "Tue",
    "Subuh": "5 42",
    "Syuruk": "6 59",
    "Zuhur": "1 04",
    "Asar": "4 10",
    "Maghrib": "7 06",
    "Isyak": "8 15"
  },
  {
    "Date": "09/09/2026",
    "Day": "Wed",
    "Subuh": "5 42",
    "Syuruk": "6 59",
    "Zuhur": "1 03",
    "Asar": "4 09",
    "Maghrib": "7 06",
    "Isyak": "8 15"
  },
  {
    "Date": "10/09/2026",
    "Day": "Thu",
    "Subuh": "5 41",
    "Syuruk": "6 58",
    "Zuhur": "1 03",
    "Asar": "4 08",
    "Maghrib": "7 06",
    "Isyak": "8 15"
  },
  {
    "Date": "11/09/2026",
    "Day": "Fri",
    "Subuh": "5 41",
    "Syuruk": "6 58",
    "Zuhur": "1 03",
    "Asar": "4 07",
    "Maghrib": "7 05",
    "Isyak": "8 14"
  },
  {
    "Date": "12/09/2026",
    "Day": "Sat",
    "Subuh": "5 41",
    "Syuruk": "6 58",
    "Zuhur": "1 02",
    "Asar": "4 06",
    "Maghrib": "7 05",
    "Isyak": "8 14"
  },
  {
    "Date": "13/09/2026",
    "Day": "Sun",
    "Subuh": "5 40",
    "Syuruk": "6 57",
    "Zuhur": "1 02",
    "Asar": "4 05",
    "Maghrib": "7 05",
    "Isyak": "8 13"
  },
  {
    "Date": "14/09/2026",
    "Day": "Mon",
    "Subuh": "5 40",
    "Syuruk": "6 57",
    "Zuhur": "1 02",
    "Asar": "4 04",
    "Maghrib": "7 04",
    "Isyak": "8 13"
  },
  {
    "Date": "15/09/2026",
    "Day": "Tue",
    "Subuh": "5 40",
    "Syuruk": "6 57",
    "Zuhur": "1 01",
    "Asar": "4 03",
    "Maghrib": "7 04",
    "Isyak": "8 13"
  },
  {
    "Date": "16/09/2026",
    "Day": "Wed",
    "Subuh": "5 40",
    "Syuruk": "6 56",
    "Zuhur": "1 01",
    "Asar": "4 02",
    "Maghrib": "7 03",
    "Isyak": "8 12"
  },
  {
    "Date": "17/09/2026",
    "Day": "Thu",
    "Subuh": "5 39",
    "Syuruk": "6 56",
    "Zuhur": "1 01",
    "Asar": "4 01",
    "Maghrib": "7 03",
    "Isyak": "8 12"
  },
  {
    "Date": "18/09/2026",
    "Day": "Fri",
    "Subuh": "5 39",
    "Syuruk": "6 56",
    "Zuhur": "1 00",
    "Asar": "4 00",
    "Maghrib": "7 03",
    "Isyak": "8 11"
  },
  {
    "Date": "19/09/2026",
    "Day": "Sat",
    "Subuh": "5 39",
    "Syuruk": "6 55",
    "Zuhur": "1 00",
    "Asar": "3 59",
    "Maghrib": "7 02",
    "Isyak": "8 11"
  },
  {
    "Date": "20/09/2026",
    "Day": "Sun",
    "Subuh": "5 38",
    "Syuruk": "6 55",
    "Zuhur": "12 59",
    "Asar": "4 00",
    "Maghrib": "7 02",
    "Isyak": "8 10"
  },
  {
    "Date": "21/09/2026",
    "Day": "Mon",
    "Subuh": "5 38",
    "Syuruk": "6 55",
    "Zuhur": "12 59",
    "Asar": "4 00",
    "Maghrib": "7 01",
    "Isyak": "8 10"
  },
  {
    "Date": "22/09/2026",
    "Day": "Tue",
    "Subuh": "5 38",
    "Syuruk": "6 54",
    "Zuhur": "12 59",
    "Asar": "4 00",
    "Maghrib": "7 01",
    "Isyak": "8 10"
  },
  {
    "Date": "23/09/2026",
    "Day": "Wed",
    "Subuh": "5 37",
    "Syuruk": "6 54",
    "Zuhur": "12 58",
    "Asar": "4 01",
    "Maghrib": "7 01",
    "Isyak": "8 09"
  },
  {
    "Date": "24/09/2026",
    "Day": "Thu",
    "Subuh": "5 37",
    "Syuruk": "6 54",
    "Zuhur": "12 58",
    "Asar": "4 01",
    "Maghrib": "7 00",
    "Isyak": "8 09"
  },
  {
    "Date": "25/09/2026",
    "Day": "Fri",
    "Subuh": "5 37",
    "Syuruk": "6 53",
    "Zuhur": "12 58",
    "Asar": "4 01",
    "Maghrib": "7 00",
    "Isyak": "8 09"
  },
  {
    "Date": "26/09/2026",
    "Day": "Sat",
    "Subuh": "5 36",
    "Syuruk": "6 53",
    "Zuhur": "12 57",
    "Asar": "4 02",
    "Maghrib": "6 59",
    "Isyak": "8 08"
  },
  {
    "Date": "27/09/2026",
    "Day": "Sun",
    "Subuh": "5 36",
    "Syuruk": "6 53",
    "Zuhur": "12 57",
    "Asar": "4 02",
    "Maghrib": "6 59",
    "Isyak": "8 08"
  },
  {
    "Date": "28/09/2026",
    "Day": "Mon",
    "Subuh": "5 36",
    "Syuruk": "6 53",
    "Zuhur": "12 57",
    "Asar": "4 02",
    "Maghrib": "6 59",
    "Isyak": "8 07"
  },
  {
    "Date": "29/09/2026",
    "Day": "Tue",
    "Subuh": "5 35",
    "Syuruk": "6 52",
    "Zuhur": "12 56",
    "Asar": "4 03",
    "Maghrib": "6 58",
    "Isyak": "8 07"
  },
  {
    "Date": "30/09/2026",
    "Day": "Wed",
    "Subuh": "5 35",
    "Syuruk": "6 52",
    "Zuhur": "12 56",
    "Asar": "4 03",
    "Maghrib": "6 58",
    "Isyak": "8 07"
  },
  {
    "Date": "01/10/2026",
    "Day": "Thu",
    "Subuh": "5 35",
    "Syuruk": "6 52",
    "Zuhur": "12 56",
    "Asar": "4 03",
    "Maghrib": "6 58",
    "Isyak": "8 06"
  },
  {
    "Date": "02/10/2026",
    "Day": "Fri",
    "Subuh": "5 34",
    "Syuruk": "6 51",
    "Zuhur": "12 55",
    "Asar": "4 03",
    "Maghrib": "6 57",
    "Isyak": "8 06"
  },
  {
    "Date": "03/10/2026",
    "Day": "Sat",
    "Subuh": "5 34",
    "Syuruk": "6 51",
    "Zuhur": "12 55",
    "Asar": "4 04",
    "Maghrib": "6 57",
    "Isyak": "8 06"
  },
  {
    "Date": "04/10/2026",
    "Day": "Sun",
    "Subuh": "5 34",
    "Syuruk": "6 51",
    "Zuhur": "12 55",
    "Asar": "4 04",
    "Maghrib": "6 57",
    "Isyak": "8 06"
  },
  {
    "Date": "05/10/2026",
    "Day": "Mon",
    "Subuh": "5 34",
    "Syuruk": "6 51",
    "Zuhur": "12 54",
    "Asar": "4 04",
    "Maghrib": "6 56",
    "Isyak": "8 05"
  },
  {
    "Date": "06/10/2026",
    "Day": "Tue",
    "Subuh": "5 33",
    "Syuruk": "6 50",
    "Zuhur": "12 54",
    "Asar": "4 04",
    "Maghrib": "6 56",
    "Isyak": "8 05"
  },
  {
    "Date": "07/10/2026",
    "Day": "Wed",
    "Subuh": "5 33",
    "Syuruk": "6 50",
    "Zuhur": "12 54",
    "Asar": "4 05",
    "Maghrib": "6 56",
    "Isyak": "8 05"
  },
  {
    "Date": "08/10/2026",
    "Day": "Thu",
    "Subuh": "5 33",
    "Syuruk": "6 50",
    "Zuhur": "12 54",
    "Asar": "4 05",
    "Maghrib": "6 55",
    "Isyak": "8 04"
  },
  {
    "Date": "09/10/2026",
    "Day": "Fri",
    "Subuh": "5 32",
    "Syuruk": "6 50",
    "Zuhur": "12 53",
    "Asar": "4 05",
    "Maghrib": "6 55",
    "Isyak": "8 04"
  },
  {
    "Date": "10/10/2026",
    "Day": "Sat",
    "Subuh": "5 32",
    "Syuruk": "6 49",
    "Zuhur": "12 53",
    "Asar": "4 05",
    "Maghrib": "6 55",
    "Isyak": "8 04"
  },
  {
    "Date": "11/10/2026",
    "Day": "Sun",
    "Subuh": "5 32",
    "Syuruk": "6 49",
    "Zuhur": "12 53",
    "Asar": "4 05",
    "Maghrib": "6 54",
    "Isyak": "8 04"
  },
  {
    "Date": "12/10/2026",
    "Day": "Mon",
    "Subuh": "5 31",
    "Syuruk": "6 49",
    "Zuhur": "12 53",
    "Asar": "4 06",
    "Maghrib": "6 54",
    "Isyak": "8 04"
  },
  {
    "Date": "13/10/2026",
    "Day": "Tue",
    "Subuh": "5 31",
    "Syuruk": "6 49",
    "Zuhur": "12 52",
    "Asar": "4 06",
    "Maghrib": "6 54",
    "Isyak": "8 03"
  },
  {
    "Date": "14/10/2026",
    "Day": "Wed",
    "Subuh": "5 31",
    "Syuruk": "6 48",
    "Zuhur": "12 52",
    "Asar": "4 06",
    "Maghrib": "6 54",
    "Isyak": "8 03"
  },
  {
    "Date": "15/10/2026",
    "Day": "Thu",
    "Subuh": "5 31",
    "Syuruk": "6 48",
    "Zuhur": "12 52",
    "Asar": "4 06",
    "Maghrib": "6 53",
    "Isyak": "8 03"
  },
  {
    "Date": "16/10/2026",
    "Day": "Fri",
    "Subuh": "5 30",
    "Syuruk": "6 48",
    "Zuhur": "12 52",
    "Asar": "4 06",
    "Maghrib": "6 53",
    "Isyak": "8 03"
  },
  {
    "Date": "17/10/2026",
    "Day": "Sat",
    "Subuh": "5 30",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 53",
    "Isyak": "8 03"
  },
  {
    "Date": "18/10/2026",
    "Day": "Sun",
    "Subuh": "5 30",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 53",
    "Isyak": "8 02"
  },
  {
    "Date": "19/10/2026",
    "Day": "Mon",
    "Subuh": "5 30",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 53",
    "Isyak": "8 02"
  },
  {
    "Date": "20/10/2026",
    "Day": "Tue",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "21/10/2026",
    "Day": "Wed",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "22/10/2026",
    "Day": "Thu",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 51",
    "Asar": "4 07",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "23/10/2026",
    "Day": "Fri",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 51",
    "Asar": "4 08",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "24/10/2026",
    "Day": "Sat",
    "Subuh": "5 29",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "25/10/2026",
    "Day": "Sun",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 52",
    "Isyak": "8 02"
  },
  {
    "Date": "26/10/2026",
    "Day": "Mon",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "27/10/2026",
    "Day": "Tue",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 08",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "28/10/2026",
    "Day": "Wed",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "29/10/2026",
    "Day": "Thu",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "30/10/2026",
    "Day": "Fri",
    "Subuh": "5 28",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "31/10/2026",
    "Day": "Sat",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "01/11/2026",
    "Day": "Sun",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 09",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "02/11/2026",
    "Day": "Mon",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "03/11/2026",
    "Day": "Tue",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "04/11/2026",
    "Day": "Wed",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "05/11/2026",
    "Day": "Thu",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 10",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "06/11/2026",
    "Day": "Fri",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 11",
    "Maghrib": "6 51",
    "Isyak": "8 02"
  },
  {
    "Date": "07/11/2026",
    "Day": "Sat",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 11",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "08/11/2026",
    "Day": "Sun",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 11",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "09/11/2026",
    "Day": "Mon",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 11",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "10/11/2026",
    "Day": "Tue",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 12",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "11/11/2026",
    "Day": "Wed",
    "Subuh": "5 27",
    "Syuruk": "6 47",
    "Zuhur": "12 50",
    "Asar": "4 12",
    "Maghrib": "6 51",
    "Isyak": "8 03"
  },
  {
    "Date": "12/11/2026",
    "Day": "Thu",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 12",
    "Maghrib": "6 51",
    "Isyak": "8 04"
  },
  {
    "Date": "13/11/2026",
    "Day": "Fri",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 13",
    "Maghrib": "6 51",
    "Isyak": "8 04"
  },
  {
    "Date": "14/11/2026",
    "Day": "Sat",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 13",
    "Maghrib": "6 52",
    "Isyak": "8 04"
  },
  {
    "Date": "15/11/2026",
    "Day": "Sun",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 13",
    "Maghrib": "6 52",
    "Isyak": "8 04"
  },
  {
    "Date": "16/11/2026",
    "Day": "Mon",
    "Subuh": "5 27",
    "Syuruk": "6 48",
    "Zuhur": "12 51",
    "Asar": "4 13",
    "Maghrib": "6 52",
    "Isyak": "8 05"
  },
  {
    "Date": "17/11/2026",
    "Day": "Tue",
    "Subuh": "5 27",
    "Syuruk": "6 49",
    "Zuhur": "12 51",
    "Asar": "4 14",
    "Maghrib": "6 52",
    "Isyak": "8 05"
  },
  {
    "Date": "18/11/2026",
    "Day": "Wed",
    "Subuh": "5 27",
    "Syuruk": "6 49",
    "Zuhur": "12 52",
    "Asar": "4 14",
    "Maghrib": "6 52",
    "Isyak": "8 05"
  },
  {
    "Date": "19/11/2026",
    "Day": "Thu",
    "Subuh": "5 27",
    "Syuruk": "6 49",
    "Zuhur": "12 52",
    "Asar": "4 14",
    "Maghrib": "6 52",
    "Isyak": "8 06"
  },
  {
    "Date": "20/11/2026",
    "Day": "Fri",
    "Subuh": "5 28",
    "Syuruk": "6 49",
    "Zuhur": "12 52",
    "Asar": "4 15",
    "Maghrib": "6 53",
    "Isyak": "8 06"
  },
  {
    "Date": "21/11/2026",
    "Day": "Sat",
    "Subuh": "5 28",
    "Syuruk": "6 50",
    "Zuhur": "12 52",
    "Asar": "4 15",
    "Maghrib": "6 53",
    "Isyak": "8 06"
  },
  {
    "Date": "22/11/2026",
    "Day": "Sun",
    "Subuh": "5 28",
    "Syuruk": "6 50",
    "Zuhur": "12 53",
    "Asar": "4 16",
    "Maghrib": "6 53",
    "Isyak": "8 07"
  },
  {
    "Date": "23/11/2026",
    "Day": "Mon",
    "Subuh": "5 28",
    "Syuruk": "6 50",
    "Zuhur": "12 53",
    "Asar": "4 16",
    "Maghrib": "6 53",
    "Isyak": "8 07"
  },
  {
    "Date": "24/11/2026",
    "Day": "Tue",
    "Subuh": "5 28",
    "Syuruk": "6 50",
    "Zuhur": "12 53",
    "Asar": "4 16",
    "Maghrib": "6 54",
    "Isyak": "8 07"
  },
  {
    "Date": "25/11/2026",
    "Day": "Wed",
    "Subuh": "5 29",
    "Syuruk": "6 51",
    "Zuhur": "12 53",
    "Asar": "4 17",
    "Maghrib": "6 54",
    "Isyak": "8 08"
  },
  {
    "Date": "26/11/2026",
    "Day": "Thu",
    "Subuh": "5 29",
    "Syuruk": "6 51",
    "Zuhur": "12 54",
    "Asar": "4 17",
    "Maghrib": "6 54",
    "Isyak": "8 08"
  },
  {
    "Date": "27/11/2026",
    "Day": "Fri",
    "Subuh": "5 29",
    "Syuruk": "6 51",
    "Zuhur": "12 54",
    "Asar": "4 17",
    "Maghrib": "6 55",
    "Isyak": "8 08"
  },
  {
    "Date": "28/11/2026",
    "Day": "Sat",
    "Subuh": "5 29",
    "Syuruk": "6 52",
    "Zuhur": "12 54",
    "Asar": "4 18",
    "Maghrib": "6 55",
    "Isyak": "8 09"
  },
  {
    "Date": "29/11/2026",
    "Day": "Sun",
    "Subuh": "5 30",
    "Syuruk": "6 52",
    "Zuhur": "12 55",
    "Asar": "4 18",
    "Maghrib": "6 55",
    "Isyak": "8 09"
  },
  {
    "Date": "30/11/2026",
    "Day": "Mon",
    "Subuh": "5 30",
    "Syuruk": "6 53",
    "Zuhur": "12 55",
    "Asar": "4 19",
    "Maghrib": "6 56",
    "Isyak": "8 10"
  },
  {
    "Date": "01/12/2026",
    "Day": "Tue",
    "Subuh": "5 30",
    "Syuruk": "6 53",
    "Zuhur": "12 56",
    "Asar": "4 19",
    "Maghrib": "6 56",
    "Isyak": "8 10"
  },
  {
    "Date": "02/12/2026",
    "Day": "Wed",
    "Subuh": "5 30",
    "Syuruk": "6 53",
    "Zuhur": "12 56",
    "Asar": "4 20",
    "Maghrib": "6 56",
    "Isyak": "8 11"
  },
  {
    "Date": "03/12/2026",
    "Day": "Thu",
    "Subuh": "5 31",
    "Syuruk": "6 54",
    "Zuhur": "12 56",
    "Asar": "4 20",
    "Maghrib": "6 57",
    "Isyak": "8 11"
  },
  {
    "Date": "04/12/2026",
    "Day": "Fri",
    "Subuh": "5 31",
    "Syuruk": "6 54",
    "Zuhur": "12 57",
    "Asar": "4 20",
    "Maghrib": "6 57",
    "Isyak": "8 12"
  },
  {
    "Date": "05/12/2026",
    "Day": "Sat",
    "Subuh": "5 31",
    "Syuruk": "6 55",
    "Zuhur": "12 57",
    "Asar": "4 21",
    "Maghrib": "6 58",
    "Isyak": "8 12"
  },
  {
    "Date": "06/12/2026",
    "Day": "Sun",
    "Subuh": "5 32",
    "Syuruk": "6 55",
    "Zuhur": "12 58",
    "Asar": "4 21",
    "Maghrib": "6 58",
    "Isyak": "8 13"
  },
  {
    "Date": "07/12/2026",
    "Day": "Mon",
    "Subuh": "5 32",
    "Syuruk": "6 55",
    "Zuhur": "12 58",
    "Asar": "4 22",
    "Maghrib": "6 58",
    "Isyak": "8 13"
  },
  {
    "Date": "08/12/2026",
    "Day": "Tue",
    "Subuh": "5 33",
    "Syuruk": "6 56",
    "Zuhur": "12 58",
    "Asar": "4 22",
    "Maghrib": "6 59",
    "Isyak": "8 14"
  },
  {
    "Date": "09/12/2026",
    "Day": "Wed",
    "Subuh": "5 33",
    "Syuruk": "6 56",
    "Zuhur": "12 59",
    "Asar": "4 23",
    "Maghrib": "6 59",
    "Isyak": "8 14"
  },
  {
    "Date": "10/12/2026",
    "Day": "Thu",
    "Subuh": "5 33",
    "Syuruk": "6 57",
    "Zuhur": "12 59",
    "Asar": "4 23",
    "Maghrib": "7 00",
    "Isyak": "8 15"
  },
  {
    "Date": "11/12/2026",
    "Day": "Fri",
    "Subuh": "5 34",
    "Syuruk": "6 57",
    "Zuhur": "1 00",
    "Asar": "4 24",
    "Maghrib": "7 00",
    "Isyak": "8 15"
  },
  {
    "Date": "12/12/2026",
    "Day": "Sat",
    "Subuh": "5 34",
    "Syuruk": "6 58",
    "Zuhur": "1 00",
    "Asar": "4 24",
    "Maghrib": "7 01",
    "Isyak": "8 16"
  },
  {
    "Date": "13/12/2026",
    "Day": "Sun",
    "Subuh": "5 35",
    "Syuruk": "6 58",
    "Zuhur": "1 01",
    "Asar": "4 25",
    "Maghrib": "7 01",
    "Isyak": "8 16"
  },
  {
    "Date": "14/12/2026",
    "Day": "Mon",
    "Subuh": "5 35",
    "Syuruk": "6 59",
    "Zuhur": "1 01",
    "Asar": "4 25",
    "Maghrib": "7 02",
    "Isyak": "8 17"
  },
  {
    "Date": "15/12/2026",
    "Day": "Tue",
    "Subuh": "5 36",
    "Syuruk": "6 59",
    "Zuhur": "1 02",
    "Asar": "4 26",
    "Maghrib": "7 02",
    "Isyak": "8 17"
  },
  {
    "Date": "16/12/2026",
    "Day": "Wed",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 02",
    "Asar": "4 26",
    "Maghrib": "7 03",
    "Isyak": "8 18"
  },
  {
    "Date": "17/12/2026",
    "Day": "Thu",
    "Subuh": "5 36",
    "Syuruk": "7 00",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 03",
    "Isyak": "8 18"
  },
  {
    "Date": "18/12/2026",
    "Day": "Fri",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 03",
    "Asar": "4 27",
    "Maghrib": "7 04",
    "Isyak": "8 19"
  },
  {
    "Date": "19/12/2026",
    "Day": "Sat",
    "Subuh": "5 37",
    "Syuruk": "7 01",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 04",
    "Isyak": "8 19"
  },
  {
    "Date": "20/12/2026",
    "Day": "Sun",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 04",
    "Asar": "4 28",
    "Maghrib": "7 05",
    "Isyak": "8 20"
  },
  {
    "Date": "21/12/2026",
    "Day": "Mon",
    "Subuh": "5 38",
    "Syuruk": "7 02",
    "Zuhur": "1 05",
    "Asar": "4 29",
    "Maghrib": "7 05",
    "Isyak": "8 20"
  },
  {
    "Date": "22/12/2026",
    "Day": "Tue",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 05",
    "Asar": "4 29",
    "Maghrib": "7 06",
    "Isyak": "8 21"
  },
  {
    "Date": "23/12/2026",
    "Day": "Wed",
    "Subuh": "5 39",
    "Syuruk": "7 03",
    "Zuhur": "1 06",
    "Asar": "4 30",
    "Maghrib": "7 06",
    "Isyak": "8 21"
  },
  {
    "Date": "24/12/2026",
    "Day": "Thu",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 06",
    "Asar": "4 30",
    "Maghrib": "7 07",
    "Isyak": "8 22"
  },
  {
    "Date": "25/12/2026",
    "Day": "Fri",
    "Subuh": "5 40",
    "Syuruk": "7 04",
    "Zuhur": "1 07",
    "Asar": "4 31",
    "Maghrib": "7 07",
    "Isyak": "8 22"
  },
  {
    "Date": "26/12/2026",
    "Day": "Sat",
    "Subuh": "5 41",
    "Syuruk": "7 05",
    "Zuhur": "1 07",
    "Asar": "4 31",
    "Maghrib": "7 08",
    "Isyak": "8 22"
  },
  {
    "Date": "27/12/2026",
    "Day": "Sun",
    "Subuh": "5 42",
    "Syuruk": "7 05",
    "Zuhur": "1 08",
    "Asar": "4 32",
    "Maghrib": "7 08",
    "Isyak": "8 23"
  },
  {
    "Date": "28/12/2026",
    "Day": "Mon",
    "Subuh": "5 42",
    "Syuruk": "7 06",
    "Zuhur": "1 08",
    "Asar": "4 32",
    "Maghrib": "7 09",
    "Isyak": "8 23"
  },
  {
    "Date": "29/12/2026",
    "Day": "Tue",
    "Subuh": "5 43",
    "Syuruk": "7 06",
    "Zuhur": "1 09",
    "Asar": "4 33",
    "Maghrib": "7 09",
    "Isyak": "8 24"
  },
  {
    "Date": "30/12/2026",
    "Day": "Wed",
    "Subuh": "5 43",
    "Syuruk": "7 07",
    "Zuhur": "1 09",
    "Asar": "4 33",
    "Maghrib": "7 10",
    "Isyak": "8 24"
  },
  {
    "Date": "31/12/2026",
    "Day": "Thu",
    "Subuh": "5 44",
    "Syuruk": "7 07",
    "Zuhur": "1 10",
    "Asar": "4 34",
    "Maghrib": "7 10",
    "Isyak": "8 25"
  }
]
